import { createApp as ia, defineComponent as tt, h as mt, provide as la, ref as Z, inject as Qn, getCurrentInstance as At, onMounted as bt, onUnmounted as Zn, shallowRef as Jt, computed as le, onBeforeMount as er, watch as Be, Fragment as tr, createVNode as sa, Text as ua, getCurrentScope as ca, onScopeDispose as fa, unref as da, nextTick as nr, readonly as rr, watchEffect as ma } from "vue";
import { parseISO as pa } from "date-fns";
import ft from "crypto";
function ar(e) {
  const t = document.createElement("div"), n = ia(e), a = () => n.unmount(), o = n.mount(t);
  return o.unmount = a, o;
}
function Cl(e) {
  const t = tt({
    setup: e,
    render() {
      return mt("div", []);
    }
  });
  return ar(t);
}
const _a = Symbol("num");
function wl(e) {
  const t = tt({
    setup: e,
    render() {
      return mt("div", []);
    }
  }), n = tt({
    components: t,
    setup() {
      la(_a, Z(1));
    },
    render() {
      return mt("div", []);
    }
  });
  return ar(n);
}
function ga() {
  const e = window || global, t = () => {
    const p = [];
    return Object.keys(e).forEach((m) => {
      p.push(m);
    }), p.length.toString(36);
  }, n = (p, m) => (new Array(m + 1).join("0") + p).slice(-m), a = navigator.userAgent.length.toString(36), o = n(a + t(), 4), r = e.screen.width.toString(36), i = e.screen.height.toString(36), u = e.screen.availWidth.toString(36), l = e.screen.availHeight.toString(36), c = e.screen.colorDepth.toString(36), d = e.screen.pixelDepth.toString(36);
  return `${o}${r}${i}${u}${l}${c}${d}`;
}
const Qt = typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {};
/*!
  * vue-router v4.2.5
  * (c) 2023 Eduardo San Martin Morote
  * @license MIT
  */
var _n;
(function(e) {
  e.pop = "pop", e.push = "push";
})(_n || (_n = {}));
var gn;
(function(e) {
  e.back = "back", e.forward = "forward", e.unknown = "";
})(gn || (gn = {}));
var vn;
(function(e) {
  e[e.aborted = 4] = "aborted", e[e.cancelled = 8] = "cancelled", e[e.duplicated = 16] = "duplicated";
})(vn || (vn = {}));
const va = Symbol(process.env.NODE_ENV !== "production" ? "router" : "");
function ba() {
  return Qn(va);
}
/*!
  * shared v9.8.0
  * (c) 2023 kazuya kawaguchi
  * Released under the MIT License.
  */
const Fe = typeof window < "u";
let pe, Ye;
if (process.env.NODE_ENV !== "production") {
  const e = Fe && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (pe = (t) => {
    e.mark(t);
  }, Ye = (t, n, a) => {
    e.measure(t, n, a), e.clearMarks(n), e.clearMarks(a);
  });
}
const ha = /\{([0-9a-zA-Z]+)\}/g;
function Zt(e, ...t) {
  return t.length === 1 && X(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(ha, (n, a) => t.hasOwnProperty(a) ? t[a] : "");
}
const we = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), Ea = (e, t, n) => ya({ l: e, k: t, s: n }), ya = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), se = (e) => typeof e == "number" && isFinite(e), Oa = (e) => ir(e) === "[object Date]", nt = (e) => ir(e) === "[object RegExp]", St = (e) => B(e) && Object.keys(e).length === 0, ue = Object.assign;
let bn;
const Ie = () => bn || (bn = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function hn(e) {
  return e.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const Na = Object.prototype.hasOwnProperty;
function pt(e, t) {
  return Na.call(e, t);
}
const re = Array.isArray, Q = (e) => typeof e == "function", F = (e) => typeof e == "string", q = (e) => typeof e == "boolean", X = (e) => e !== null && typeof e == "object", Ta = (e) => X(e) && Q(e.then) && Q(e.catch), or = Object.prototype.toString, ir = (e) => or.call(e), B = (e) => {
  if (!X(e))
    return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t.constructor === Object;
}, La = (e) => e == null ? "" : re(e) || B(e) && e.toString === or ? JSON.stringify(e, null, 2) : String(e);
function Aa(e, t = "") {
  return e.reduce((n, a, o) => o === 0 ? n + a : n + t + a, "");
}
const En = 2;
function Sa(e, t = 0, n = e.length) {
  const a = e.split(/\r?\n/);
  let o = 0;
  const r = [];
  for (let i = 0; i < a.length; i++)
    if (o += a[i].length + 1, o >= t) {
      for (let u = i - En; u <= i + En || n > o; u++) {
        if (u < 0 || u >= a.length)
          continue;
        const l = u + 1;
        r.push(`${l}${" ".repeat(3 - String(l).length)}|  ${a[u]}`);
        const c = a[u].length;
        if (u === i) {
          const d = t - (o - c) + 1, p = Math.max(1, n > o ? c - d : n - t);
          r.push("   |  " + " ".repeat(d) + "^".repeat(p));
        } else if (u > i) {
          if (n > o) {
            const d = Math.max(Math.min(n - o, c), 1);
            r.push("   |  " + "^".repeat(d));
          }
          o += c + 1;
        }
      }
      break;
    }
  return r.join(`
`);
}
function en(e) {
  let t = e;
  return () => ++t;
}
function Ue(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const yn = {};
function Ia(e) {
  yn[e] || (yn[e] = !0, Ue(e));
}
function Ca() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, a) {
      const o = e.get(n);
      o && o.push(a) || e.set(n, [a]);
    },
    off(n, a) {
      const o = e.get(n);
      o && o.splice(o.indexOf(a) >>> 0, 1);
    },
    emit(n, a) {
      (e.get(n) || []).slice().map((o) => o(a)), (e.get("*") || []).slice().map((o) => o(n, a));
    }
  };
}
const yt = (e) => !X(e) || re(e);
function dt(e, t) {
  if (yt(e) || yt(t))
    throw new Error("Invalid value");
  for (const n in e)
    pt(e, n) && (yt(e[n]) || yt(t[n]) ? t[n] = e[n] : dt(e[n], t[n]));
}
/*!
  * message-compiler v9.8.0
  * (c) 2023 kazuya kawaguchi
  * Released under the MIT License.
  */
function wa(e, t, n) {
  return { line: e, column: t, offset: n };
}
function $t(e, t, n) {
  const a = { start: e, end: t };
  return n != null && (a.source = n), a;
}
const ka = /\{([0-9a-zA-Z]+)\}/g;
function Pa(e, ...t) {
  return t.length === 1 && Da(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(ka, (n, a) => t.hasOwnProperty(a) ? t[a] : "");
}
const lr = Object.assign, On = (e) => typeof e == "string", Da = (e) => e !== null && typeof e == "object";
function sr(e, t = "") {
  return e.reduce((n, a, o) => o === 0 ? n + a : n + t + a, "");
}
const G = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16,
  // Special value for higher-order compilers to pick up the last code
  // to avoid collision of error codes. This should always be kept as the last
  // item.
  __EXTEND_POINT__: 17
}, xa = {
  // tokenizer error messages
  [G.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [G.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [G.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [G.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [G.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [G.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [G.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [G.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [G.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [G.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [G.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [G.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [G.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [G.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [G.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [G.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function ot(e, t, n = {}) {
  const { domain: a, messages: o, args: r } = n, i = Pa((o || xa)[e] || "", ...r || []), u = new SyntaxError(String(i));
  return u.code = e, t && (u.location = t), u.domain = a, u;
}
function Ra(e) {
  throw e;
}
const Ma = /<\/?[\w\s="/.':;#-\/]+>/, Fa = (e) => Ma.test(e), Se = " ", Ua = "\r", ce = `
`, $a = "\u2028", Va = "\u2029";
function Wa(e) {
  const t = e;
  let n = 0, a = 1, o = 1, r = 0;
  const i = (N) => t[N] === Ua && t[N + 1] === ce, u = (N) => t[N] === ce, l = (N) => t[N] === Va, c = (N) => t[N] === $a, d = (N) => i(N) || u(N) || l(N) || c(N), p = () => n, m = () => a, E = () => o, h = () => r, T = (N) => i(N) || l(N) || c(N) ? ce : t[N], S = () => T(n), _ = () => T(n + r);
  function g() {
    return r = 0, d(n) && (a++, o = 0), i(n) && n++, n++, o++, t[n];
  }
  function O() {
    return i(n + r) && r++, r++, t[n + r];
  }
  function v() {
    n = 0, a = 1, o = 1, r = 0;
  }
  function P(N = 0) {
    r = N;
  }
  function C() {
    const N = n + r;
    for (; N !== n; )
      g();
    r = 0;
  }
  return {
    index: p,
    line: m,
    column: E,
    peekOffset: h,
    charAt: T,
    currentChar: S,
    currentPeek: _,
    next: g,
    peek: O,
    reset: v,
    resetPeek: P,
    skipToPeek: C
  };
}
const Pe = void 0, ja = ".", Nn = "'", Ga = "tokenizer";
function Ha(e, t = {}) {
  const n = t.location !== !1, a = Wa(e), o = () => a.index(), r = () => wa(a.line(), a.column(), a.index()), i = r(), u = o(), l = {
    currentType: 14,
    offset: u,
    startLoc: i,
    endLoc: i,
    lastType: 14,
    lastOffset: u,
    lastStartLoc: i,
    lastEndLoc: i,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, c = () => l, { onError: d } = t;
  function p(s, f, A, ...M) {
    const H = c();
    if (f.column += A, f.offset += A, d) {
      const K = n ? $t(H.startLoc, f) : null, Ee = ot(s, K, {
        domain: Ga,
        args: M
      });
      d(Ee);
    }
  }
  function m(s, f, A) {
    s.endLoc = r(), s.currentType = f;
    const M = { type: f };
    return n && (M.loc = $t(s.startLoc, s.endLoc)), A != null && (M.value = A), M;
  }
  const E = (s) => m(
    s,
    14
    /* TokenTypes.EOF */
  );
  function h(s, f) {
    return s.currentChar() === f ? (s.next(), f) : (p(G.EXPECTED_TOKEN, r(), 0, f), "");
  }
  function T(s) {
    let f = "";
    for (; s.currentPeek() === Se || s.currentPeek() === ce; )
      f += s.currentPeek(), s.peek();
    return f;
  }
  function S(s) {
    const f = T(s);
    return s.skipToPeek(), f;
  }
  function _(s) {
    if (s === Pe)
      return !1;
    const f = s.charCodeAt(0);
    return f >= 97 && f <= 122 || // a-z
    f >= 65 && f <= 90 || // A-Z
    f === 95;
  }
  function g(s) {
    if (s === Pe)
      return !1;
    const f = s.charCodeAt(0);
    return f >= 48 && f <= 57;
  }
  function O(s, f) {
    const { currentType: A } = f;
    if (A !== 2)
      return !1;
    T(s);
    const M = _(s.currentPeek());
    return s.resetPeek(), M;
  }
  function v(s, f) {
    const { currentType: A } = f;
    if (A !== 2)
      return !1;
    T(s);
    const M = s.currentPeek() === "-" ? s.peek() : s.currentPeek(), H = g(M);
    return s.resetPeek(), H;
  }
  function P(s, f) {
    const { currentType: A } = f;
    if (A !== 2)
      return !1;
    T(s);
    const M = s.currentPeek() === Nn;
    return s.resetPeek(), M;
  }
  function C(s, f) {
    const { currentType: A } = f;
    if (A !== 8)
      return !1;
    T(s);
    const M = s.currentPeek() === ".";
    return s.resetPeek(), M;
  }
  function N(s, f) {
    const { currentType: A } = f;
    if (A !== 9)
      return !1;
    T(s);
    const M = _(s.currentPeek());
    return s.resetPeek(), M;
  }
  function W(s, f) {
    const { currentType: A } = f;
    if (!(A === 8 || A === 12))
      return !1;
    T(s);
    const M = s.currentPeek() === ":";
    return s.resetPeek(), M;
  }
  function b(s, f) {
    const { currentType: A } = f;
    if (A !== 10)
      return !1;
    const M = () => {
      const K = s.currentPeek();
      return K === "{" ? _(s.peek()) : K === "@" || K === "%" || K === "|" || K === ":" || K === "." || K === Se || !K ? !1 : K === ce ? (s.peek(), M()) : _(K);
    }, H = M();
    return s.resetPeek(), H;
  }
  function w(s) {
    T(s);
    const f = s.currentPeek() === "|";
    return s.resetPeek(), f;
  }
  function R(s) {
    const f = T(s), A = s.currentPeek() === "%" && s.peek() === "{";
    return s.resetPeek(), {
      isModulo: A,
      hasSpace: f.length > 0
    };
  }
  function I(s, f = !0) {
    const A = (H = !1, K = "", Ee = !1) => {
      const Ae = s.currentPeek();
      return Ae === "{" ? K === "%" ? !1 : H : Ae === "@" || !Ae ? K === "%" ? !0 : H : Ae === "%" ? (s.peek(), A(H, "%", !0)) : Ae === "|" ? K === "%" || Ee ? !0 : !(K === Se || K === ce) : Ae === Se ? (s.peek(), A(!0, Se, Ee)) : Ae === ce ? (s.peek(), A(!0, ce, Ee)) : !0;
    }, M = A();
    return f && s.resetPeek(), M;
  }
  function x(s, f) {
    const A = s.currentChar();
    return A === Pe ? Pe : f(A) ? (s.next(), A) : null;
  }
  function U(s) {
    return x(s, (A) => {
      const M = A.charCodeAt(0);
      return M >= 97 && M <= 122 || // a-z
      M >= 65 && M <= 90 || // A-Z
      M >= 48 && M <= 57 || // 0-9
      M === 95 || // _
      M === 36;
    });
  }
  function D(s) {
    return x(s, (A) => {
      const M = A.charCodeAt(0);
      return M >= 48 && M <= 57;
    });
  }
  function L(s) {
    return x(s, (A) => {
      const M = A.charCodeAt(0);
      return M >= 48 && M <= 57 || // 0-9
      M >= 65 && M <= 70 || // A-F
      M >= 97 && M <= 102;
    });
  }
  function V(s) {
    let f = "", A = "";
    for (; f = D(s); )
      A += f;
    return A;
  }
  function j(s) {
    S(s);
    const f = s.currentChar();
    return f !== "%" && p(G.EXPECTED_TOKEN, r(), 0, f), s.next(), "%";
  }
  function $(s) {
    let f = "";
    for (; ; ) {
      const A = s.currentChar();
      if (A === "{" || A === "}" || A === "@" || A === "|" || !A)
        break;
      if (A === "%")
        if (I(s))
          f += A, s.next();
        else
          break;
      else if (A === Se || A === ce)
        if (I(s))
          f += A, s.next();
        else {
          if (w(s))
            break;
          f += A, s.next();
        }
      else
        f += A, s.next();
    }
    return f;
  }
  function Y(s) {
    S(s);
    let f = "", A = "";
    for (; f = U(s); )
      A += f;
    return s.currentChar() === Pe && p(G.UNTERMINATED_CLOSING_BRACE, r(), 0), A;
  }
  function Ne(s) {
    S(s);
    let f = "";
    return s.currentChar() === "-" ? (s.next(), f += `-${V(s)}`) : f += V(s), s.currentChar() === Pe && p(G.UNTERMINATED_CLOSING_BRACE, r(), 0), f;
  }
  function oe(s) {
    S(s), h(s, "'");
    let f = "", A = "";
    const M = (K) => K !== Nn && K !== ce;
    for (; f = x(s, M); )
      f === "\\" ? A += he(s) : A += f;
    const H = s.currentChar();
    return H === ce || H === Pe ? (p(G.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, r(), 0), H === ce && (s.next(), h(s, "'")), A) : (h(s, "'"), A);
  }
  function he(s) {
    const f = s.currentChar();
    switch (f) {
      case "\\":
      case "'":
        return s.next(), `\\${f}`;
      case "u":
        return Te(s, f, 4);
      case "U":
        return Te(s, f, 6);
      default:
        return p(G.UNKNOWN_ESCAPE_SEQUENCE, r(), 0, f), "";
    }
  }
  function Te(s, f, A) {
    h(s, f);
    let M = "";
    for (let H = 0; H < A; H++) {
      const K = L(s);
      if (!K) {
        p(G.INVALID_UNICODE_ESCAPE_SEQUENCE, r(), 0, `\\${f}${M}${s.currentChar()}`);
        break;
      }
      M += K;
    }
    return `\\${f}${M}`;
  }
  function ke(s) {
    S(s);
    let f = "", A = "";
    const M = (H) => H !== "{" && H !== "}" && H !== Se && H !== ce;
    for (; f = x(s, M); )
      A += f;
    return A;
  }
  function ie(s) {
    let f = "", A = "";
    for (; f = U(s); )
      A += f;
    return A;
  }
  function me(s) {
    const f = (A = !1, M) => {
      const H = s.currentChar();
      return H === "{" || H === "%" || H === "@" || H === "|" || H === "(" || H === ")" || !H || H === Se ? M : H === ce || H === ja ? (M += H, s.next(), f(A, M)) : (M += H, s.next(), f(!0, M));
    };
    return f(!1, "");
  }
  function _e(s) {
    S(s);
    const f = h(
      s,
      "|"
      /* TokenChars.Pipe */
    );
    return S(s), f;
  }
  function Le(s, f) {
    let A = null;
    switch (s.currentChar()) {
      case "{":
        return f.braceNest >= 1 && p(G.NOT_ALLOW_NEST_PLACEHOLDER, r(), 0), s.next(), A = m(
          f,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), S(s), f.braceNest++, A;
      case "}":
        return f.braceNest > 0 && f.currentType === 2 && p(G.EMPTY_PLACEHOLDER, r(), 0), s.next(), A = m(
          f,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), f.braceNest--, f.braceNest > 0 && S(s), f.inLinked && f.braceNest === 0 && (f.inLinked = !1), A;
      case "@":
        return f.braceNest > 0 && p(G.UNTERMINATED_CLOSING_BRACE, r(), 0), A = ge(s, f) || E(f), f.braceNest = 0, A;
      default:
        let H = !0, K = !0, Ee = !0;
        if (w(s))
          return f.braceNest > 0 && p(G.UNTERMINATED_CLOSING_BRACE, r(), 0), A = m(f, 1, _e(s)), f.braceNest = 0, f.inLinked = !1, A;
        if (f.braceNest > 0 && (f.currentType === 5 || f.currentType === 6 || f.currentType === 7))
          return p(G.UNTERMINATED_CLOSING_BRACE, r(), 0), f.braceNest = 0, Ve(s, f);
        if (H = O(s, f))
          return A = m(f, 5, Y(s)), S(s), A;
        if (K = v(s, f))
          return A = m(f, 6, Ne(s)), S(s), A;
        if (Ee = P(s, f))
          return A = m(f, 7, oe(s)), S(s), A;
        if (!H && !K && !Ee)
          return A = m(f, 13, ke(s)), p(G.INVALID_TOKEN_IN_PLACEHOLDER, r(), 0, A.value), S(s), A;
        break;
    }
    return A;
  }
  function ge(s, f) {
    const { currentType: A } = f;
    let M = null;
    const H = s.currentChar();
    switch ((A === 8 || A === 9 || A === 12 || A === 10) && (H === ce || H === Se) && p(G.INVALID_LINKED_FORMAT, r(), 0), H) {
      case "@":
        return s.next(), M = m(
          f,
          8,
          "@"
          /* TokenChars.LinkedAlias */
        ), f.inLinked = !0, M;
      case ".":
        return S(s), s.next(), m(
          f,
          9,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return S(s), s.next(), m(
          f,
          10,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return w(s) ? (M = m(f, 1, _e(s)), f.braceNest = 0, f.inLinked = !1, M) : C(s, f) || W(s, f) ? (S(s), ge(s, f)) : N(s, f) ? (S(s), m(f, 12, ie(s))) : b(s, f) ? (S(s), H === "{" ? Le(s, f) || M : m(f, 11, me(s))) : (A === 8 && p(G.INVALID_LINKED_FORMAT, r(), 0), f.braceNest = 0, f.inLinked = !1, Ve(s, f));
    }
  }
  function Ve(s, f) {
    let A = {
      type: 14
      /* TokenTypes.EOF */
    };
    if (f.braceNest > 0)
      return Le(s, f) || E(f);
    if (f.inLinked)
      return ge(s, f) || E(f);
    switch (s.currentChar()) {
      case "{":
        return Le(s, f) || E(f);
      case "}":
        return p(G.UNBALANCED_CLOSING_BRACE, r(), 0), s.next(), m(
          f,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return ge(s, f) || E(f);
      default:
        if (w(s))
          return A = m(f, 1, _e(s)), f.braceNest = 0, f.inLinked = !1, A;
        const { isModulo: H, hasSpace: K } = R(s);
        if (H)
          return K ? m(f, 0, $(s)) : m(f, 4, j(s));
        if (I(s))
          return m(f, 0, $(s));
        break;
    }
    return A;
  }
  function it() {
    const { currentType: s, offset: f, startLoc: A, endLoc: M } = l;
    return l.lastType = s, l.lastOffset = f, l.lastStartLoc = A, l.lastEndLoc = M, l.offset = o(), l.startLoc = r(), a.currentChar() === Pe ? m(
      l,
      14
      /* TokenTypes.EOF */
    ) : Ve(a, l);
  }
  return {
    nextToken: it,
    currentOffset: o,
    currentPosition: r,
    context: c
  };
}
const Ba = "parser", Ya = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function Ka(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const a = parseInt(t || n, 16);
      return a <= 55295 || a >= 57344 ? String.fromCodePoint(a) : "�";
    }
  }
}
function za(e = {}) {
  const t = e.location !== !1, { onError: n } = e;
  function a(_, g, O, v, ...P) {
    const C = _.currentPosition();
    if (C.offset += v, C.column += v, n) {
      const N = t ? $t(O, C) : null, W = ot(g, N, {
        domain: Ba,
        args: P
      });
      n(W);
    }
  }
  function o(_, g, O) {
    const v = { type: _ };
    return t && (v.start = g, v.end = g, v.loc = { start: O, end: O }), v;
  }
  function r(_, g, O, v) {
    v && (_.type = v), t && (_.end = g, _.loc && (_.loc.end = O));
  }
  function i(_, g) {
    const O = _.context(), v = o(3, O.offset, O.startLoc);
    return v.value = g, r(v, _.currentOffset(), _.currentPosition()), v;
  }
  function u(_, g) {
    const O = _.context(), { lastOffset: v, lastStartLoc: P } = O, C = o(5, v, P);
    return C.index = parseInt(g, 10), _.nextToken(), r(C, _.currentOffset(), _.currentPosition()), C;
  }
  function l(_, g) {
    const O = _.context(), { lastOffset: v, lastStartLoc: P } = O, C = o(4, v, P);
    return C.key = g, _.nextToken(), r(C, _.currentOffset(), _.currentPosition()), C;
  }
  function c(_, g) {
    const O = _.context(), { lastOffset: v, lastStartLoc: P } = O, C = o(9, v, P);
    return C.value = g.replace(Ya, Ka), _.nextToken(), r(C, _.currentOffset(), _.currentPosition()), C;
  }
  function d(_) {
    const g = _.nextToken(), O = _.context(), { lastOffset: v, lastStartLoc: P } = O, C = o(8, v, P);
    return g.type !== 12 ? (a(_, G.UNEXPECTED_EMPTY_LINKED_MODIFIER, O.lastStartLoc, 0), C.value = "", r(C, v, P), {
      nextConsumeToken: g,
      node: C
    }) : (g.value == null && a(_, G.UNEXPECTED_LEXICAL_ANALYSIS, O.lastStartLoc, 0, ye(g)), C.value = g.value || "", r(C, _.currentOffset(), _.currentPosition()), {
      node: C
    });
  }
  function p(_, g) {
    const O = _.context(), v = o(7, O.offset, O.startLoc);
    return v.value = g, r(v, _.currentOffset(), _.currentPosition()), v;
  }
  function m(_) {
    const g = _.context(), O = o(6, g.offset, g.startLoc);
    let v = _.nextToken();
    if (v.type === 9) {
      const P = d(_);
      O.modifier = P.node, v = P.nextConsumeToken || _.nextToken();
    }
    switch (v.type !== 10 && a(_, G.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, ye(v)), v = _.nextToken(), v.type === 2 && (v = _.nextToken()), v.type) {
      case 11:
        v.value == null && a(_, G.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, ye(v)), O.key = p(_, v.value || "");
        break;
      case 5:
        v.value == null && a(_, G.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, ye(v)), O.key = l(_, v.value || "");
        break;
      case 6:
        v.value == null && a(_, G.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, ye(v)), O.key = u(_, v.value || "");
        break;
      case 7:
        v.value == null && a(_, G.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, ye(v)), O.key = c(_, v.value || "");
        break;
      default:
        a(_, G.UNEXPECTED_EMPTY_LINKED_KEY, g.lastStartLoc, 0);
        const P = _.context(), C = o(7, P.offset, P.startLoc);
        return C.value = "", r(C, P.offset, P.startLoc), O.key = C, r(O, P.offset, P.startLoc), {
          nextConsumeToken: v,
          node: O
        };
    }
    return r(O, _.currentOffset(), _.currentPosition()), {
      node: O
    };
  }
  function E(_) {
    const g = _.context(), O = g.currentType === 1 ? _.currentOffset() : g.offset, v = g.currentType === 1 ? g.endLoc : g.startLoc, P = o(2, O, v);
    P.items = [];
    let C = null;
    do {
      const b = C || _.nextToken();
      switch (C = null, b.type) {
        case 0:
          b.value == null && a(_, G.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, ye(b)), P.items.push(i(_, b.value || ""));
          break;
        case 6:
          b.value == null && a(_, G.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, ye(b)), P.items.push(u(_, b.value || ""));
          break;
        case 5:
          b.value == null && a(_, G.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, ye(b)), P.items.push(l(_, b.value || ""));
          break;
        case 7:
          b.value == null && a(_, G.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, ye(b)), P.items.push(c(_, b.value || ""));
          break;
        case 8:
          const w = m(_);
          P.items.push(w.node), C = w.nextConsumeToken || null;
          break;
      }
    } while (g.currentType !== 14 && g.currentType !== 1);
    const N = g.currentType === 1 ? g.lastOffset : _.currentOffset(), W = g.currentType === 1 ? g.lastEndLoc : _.currentPosition();
    return r(P, N, W), P;
  }
  function h(_, g, O, v) {
    const P = _.context();
    let C = v.items.length === 0;
    const N = o(1, g, O);
    N.cases = [], N.cases.push(v);
    do {
      const W = E(_);
      C || (C = W.items.length === 0), N.cases.push(W);
    } while (P.currentType !== 14);
    return C && a(_, G.MUST_HAVE_MESSAGES_IN_PLURAL, O, 0), r(N, _.currentOffset(), _.currentPosition()), N;
  }
  function T(_) {
    const g = _.context(), { offset: O, startLoc: v } = g, P = E(_);
    return g.currentType === 14 ? P : h(_, O, v, P);
  }
  function S(_) {
    const g = Ha(_, lr({}, e)), O = g.context(), v = o(0, O.offset, O.startLoc);
    return t && v.loc && (v.loc.source = _), v.body = T(g), e.onCacheKey && (v.cacheKey = e.onCacheKey(_)), O.currentType !== 14 && a(g, G.UNEXPECTED_LEXICAL_ANALYSIS, O.lastStartLoc, 0, _[O.offset] || ""), r(v, g.currentOffset(), g.currentPosition()), v;
  }
  return { parse: S };
}
function ye(e) {
  if (e.type === 14)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function Xa(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (r) => (n.helpers.add(r), r) };
}
function Tn(e, t) {
  for (let n = 0; n < e.length; n++)
    tn(e[n], t);
}
function tn(e, t) {
  switch (e.type) {
    case 1:
      Tn(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      Tn(e.items, t);
      break;
    case 6:
      tn(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function qa(e, t = {}) {
  const n = Xa(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && tn(e.body, n);
  const a = n.context();
  e.helpers = Array.from(a.helpers);
}
function Ja(e) {
  const t = e.body;
  return t.type === 2 ? Ln(t) : t.cases.forEach((n) => Ln(n)), e;
}
function Ln(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const a = e.items[n];
      if (!(a.type === 3 || a.type === 9) || a.value == null)
        break;
      t.push(a.value);
    }
    if (t.length === e.items.length) {
      e.static = sr(t);
      for (let n = 0; n < e.items.length; n++) {
        const a = e.items[n];
        (a.type === 3 || a.type === 9) && delete a.value;
      }
    }
  }
}
const Qa = "minifier";
function Je(e) {
  switch (e.t = e.type, e.type) {
    case 0:
      const t = e;
      Je(t.body), t.b = t.body, delete t.body;
      break;
    case 1:
      const n = e, a = n.cases;
      for (let d = 0; d < a.length; d++)
        Je(a[d]);
      n.c = a, delete n.cases;
      break;
    case 2:
      const o = e, r = o.items;
      for (let d = 0; d < r.length; d++)
        Je(r[d]);
      o.i = r, delete o.items, o.static && (o.s = o.static, delete o.static);
      break;
    case 3:
    case 9:
    case 8:
    case 7:
      const i = e;
      i.value && (i.v = i.value, delete i.value);
      break;
    case 6:
      const u = e;
      Je(u.key), u.k = u.key, delete u.key, u.modifier && (Je(u.modifier), u.m = u.modifier, delete u.modifier);
      break;
    case 5:
      const l = e;
      l.i = l.index, delete l.index;
      break;
    case 4:
      const c = e;
      c.k = c.key, delete c.key;
      break;
    default:
      throw ot(G.UNHANDLED_MINIFIER_NODE_TYPE, null, {
        domain: Qa,
        args: [e.type]
      });
  }
  delete e.type;
}
const Za = "parser";
function eo(e, t) {
  const { sourceMap: n, filename: a, breakLineCode: o, needIndent: r } = t, i = t.location !== !1, u = {
    filename: a,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: o,
    needIndent: r,
    indentLevel: 0
  };
  i && e.loc && (u.source = e.loc.source);
  const l = () => u;
  function c(S, _) {
    u.code += S;
  }
  function d(S, _ = !0) {
    const g = _ ? o : "";
    c(r ? g + "  ".repeat(S) : g);
  }
  function p(S = !0) {
    const _ = ++u.indentLevel;
    S && d(_);
  }
  function m(S = !0) {
    const _ = --u.indentLevel;
    S && d(_);
  }
  function E() {
    d(u.indentLevel);
  }
  return {
    context: l,
    push: c,
    indent: p,
    deindent: m,
    newline: E,
    helper: (S) => `_${S}`,
    needIndent: () => u.needIndent
  };
}
function to(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), rt(e, t.key), t.modifier ? (e.push(", "), rt(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function no(e, t) {
  const { helper: n, needIndent: a } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(a());
  const o = t.items.length;
  for (let r = 0; r < o && (rt(e, t.items[r]), r !== o - 1); r++)
    e.push(", ");
  e.deindent(a()), e.push("])");
}
function ro(e, t) {
  const { helper: n, needIndent: a } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(a());
    const o = t.cases.length;
    for (let r = 0; r < o && (rt(e, t.cases[r]), r !== o - 1); r++)
      e.push(", ");
    e.deindent(a()), e.push("])");
  }
}
function ao(e, t) {
  t.body ? rt(e, t.body) : e.push("null");
}
function rt(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      ao(e, t);
      break;
    case 1:
      ro(e, t);
      break;
    case 2:
      no(e, t);
      break;
    case 6:
      to(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      throw ot(G.UNHANDLED_CODEGEN_NODE_TYPE, null, {
        domain: Za,
        args: [t.type]
      });
  }
}
const oo = (e, t = {}) => {
  const n = On(t.mode) ? t.mode : "normal", a = On(t.filename) ? t.filename : "message.intl", o = !!t.sourceMap, r = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, i = t.needIndent ? t.needIndent : n !== "arrow", u = e.helpers || [], l = eo(e, {
    mode: n,
    filename: a,
    sourceMap: o,
    breakLineCode: r,
    needIndent: i
  });
  l.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), l.indent(i), u.length > 0 && (l.push(`const { ${sr(u.map((p) => `${p}: _${p}`), ", ")} } = ctx`), l.newline()), l.push("return "), rt(l, e), l.deindent(i), l.push("}"), delete e.helpers;
  const { code: c, map: d } = l.context();
  return {
    ast: e,
    code: c,
    map: d ? d.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function io(e, t = {}) {
  const n = lr({}, t), a = !!n.jit, o = !!n.minify, r = n.optimize == null ? !0 : n.optimize, u = za(n).parse(e);
  return a ? (r && Ja(u), o && Je(u), { ast: u, code: "" }) : (qa(u, n), oo(u, n));
}
/*!
  * core-base v9.8.0
  * (c) 2023 kazuya kawaguchi
  * Released under the MIT License.
  */
function lo() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Ie().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (Ie().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Ie().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
const $e = [];
$e[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
$e[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
$e[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
$e[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
$e[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
$e[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
$e[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const so = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function uo(e) {
  return so.test(e);
}
function co(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function fo(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function mo(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : uo(t) ? co(t) : "*" + t;
}
function po(e) {
  const t = [];
  let n = -1, a = 0, o = 0, r, i, u, l, c, d, p;
  const m = [];
  m[
    0
    /* Actions.APPEND */
  ] = () => {
    i === void 0 ? i = u : i += u;
  }, m[
    1
    /* Actions.PUSH */
  ] = () => {
    i !== void 0 && (t.push(i), i = void 0);
  }, m[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    m[
      0
      /* Actions.APPEND */
    ](), o++;
  }, m[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (o > 0)
      o--, a = 4, m[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (o = 0, i === void 0 || (i = mo(i), i === !1))
        return !1;
      m[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function E() {
    const h = e[n + 1];
    if (a === 5 && h === "'" || a === 6 && h === '"')
      return n++, u = "\\" + h, m[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; a !== null; )
    if (n++, r = e[n], !(r === "\\" && E())) {
      if (l = fo(r), p = $e[a], c = p[l] || p.l || 8, c === 8 || (a = c[0], c[1] !== void 0 && (d = m[c[1]], d && (u = r, d() === !1))))
        return;
      if (a === 7)
        return t;
    }
}
const An = /* @__PURE__ */ new Map();
function _o(e, t) {
  return X(e) ? e[t] : null;
}
function go(e, t) {
  if (!X(e))
    return null;
  let n = An.get(t);
  if (n || (n = po(t), n && An.set(t, n)), !n)
    return null;
  const a = n.length;
  let o = e, r = 0;
  for (; r < a; ) {
    const i = o[n[r]];
    if (i === void 0 || Q(o))
      return null;
    o = i, r++;
  }
  return o;
}
const vo = (e) => e, bo = (e) => "", ho = "text", Eo = (e) => e.length === 0 ? "" : Aa(e), yo = La;
function Sn(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function Oo(e) {
  const t = se(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (se(e.named.count) || se(e.named.n)) ? se(e.named.count) ? e.named.count : se(e.named.n) ? e.named.n : t : t;
}
function No(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function To(e = {}) {
  const t = e.locale, n = Oo(e), a = X(e.pluralRules) && F(t) && Q(e.pluralRules[t]) ? e.pluralRules[t] : Sn, o = X(e.pluralRules) && F(t) && Q(e.pluralRules[t]) ? Sn : void 0, r = (_) => _[a(n, _.length, o)], i = e.list || [], u = (_) => i[_], l = e.named || {};
  se(e.pluralIndex) && No(n, l);
  const c = (_) => l[_];
  function d(_) {
    const g = Q(e.messages) ? e.messages(_) : X(e.messages) ? e.messages[_] : !1;
    return g || (e.parent ? e.parent.message(_) : bo);
  }
  const p = (_) => e.modifiers ? e.modifiers[_] : vo, m = B(e.processor) && Q(e.processor.normalize) ? e.processor.normalize : Eo, E = B(e.processor) && Q(e.processor.interpolate) ? e.processor.interpolate : yo, h = B(e.processor) && F(e.processor.type) ? e.processor.type : ho, S = {
    list: u,
    named: c,
    plural: r,
    linked: (_, ...g) => {
      const [O, v] = g;
      let P = "text", C = "";
      g.length === 1 ? X(O) ? (C = O.modifier || C, P = O.type || P) : F(O) && (C = O || C) : g.length === 2 && (F(O) && (C = O || C), F(v) && (P = v || P));
      const N = d(_)(S), W = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        P === "vnode" && re(N) && C ? N[0] : N
      );
      return C ? p(C)(W, P) : W;
    },
    message: d,
    type: h,
    interpolate: E,
    normalize: m,
    values: ue({}, i, l)
  };
  return S;
}
let _t = null;
function Lo(e) {
  _t = e;
}
function Ao(e, t, n) {
  _t && _t.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const So = /* @__PURE__ */ Io(
  "function:translate"
  /* IntlifyDevToolsHooks.FunctionTranslate */
);
function Io(e) {
  return (t) => _t && _t.emit(e, t);
}
const fe = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7,
  __EXTEND_POINT__: 8
}, Co = {
  [fe.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [fe.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [fe.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [fe.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [fe.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [fe.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [fe.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function Ke(e, ...t) {
  return Zt(Co[e], ...t);
}
const ur = G.__EXTEND_POINT__, Ge = en(ur), ae = {
  INVALID_ARGUMENT: ur,
  INVALID_DATE_ARGUMENT: Ge(),
  INVALID_ISO_DATE_ARGUMENT: Ge(),
  NOT_SUPPORT_NON_STRING_MESSAGE: Ge(),
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: Ge(),
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: Ge(),
  NOT_SUPPORT_LOCALE_TYPE: Ge(),
  __EXTEND_POINT__: Ge()
  // 25
};
function Oe(e) {
  return ot(e, null, process.env.NODE_ENV !== "production" ? { messages: wo } : void 0);
}
const wo = {
  [ae.INVALID_ARGUMENT]: "Invalid arguments",
  [ae.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [ae.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [ae.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [ae.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [ae.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [ae.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function nn(e, t) {
  return t.locale != null ? In(t.locale) : In(e.locale);
}
let Rt;
function In(e) {
  if (F(e))
    return e;
  if (Q(e)) {
    if (e.resolvedOnce && Rt != null)
      return Rt;
    if (e.constructor.name === "Function") {
      const t = e();
      if (Ta(t))
        throw Oe(ae.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return Rt = t;
    } else
      throw Oe(ae.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw Oe(ae.NOT_SUPPORT_LOCALE_TYPE);
}
function ko(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...re(t) ? t : X(t) ? Object.keys(t) : F(t) ? [t] : [n]
  ])];
}
function cr(e, t, n) {
  const a = F(n) ? n : gt, o = e;
  o.__localeChainCache || (o.__localeChainCache = /* @__PURE__ */ new Map());
  let r = o.__localeChainCache.get(a);
  if (!r) {
    r = [];
    let i = [n];
    for (; re(i); )
      i = Cn(r, i, t);
    const u = re(t) || !B(t) ? t : t.default ? t.default : null;
    i = F(u) ? [u] : u, re(i) && Cn(r, i, !1), o.__localeChainCache.set(a, r);
  }
  return r;
}
function Cn(e, t, n) {
  let a = !0;
  for (let o = 0; o < t.length && q(a); o++) {
    const r = t[o];
    F(r) && (a = Po(e, t[o], n));
  }
  return a;
}
function Po(e, t, n) {
  let a;
  const o = t.split("-");
  do {
    const r = o.join("-");
    a = Do(e, r, n), o.splice(-1, 1);
  } while (o.length && a === !0);
  return a;
}
function Do(e, t, n) {
  let a = !1;
  if (!e.includes(t) && (a = !0, t)) {
    a = t[t.length - 1] !== "!";
    const o = t.replace(/!/g, "");
    e.push(o), (re(n) || B(n)) && n[o] && (a = n[o]);
  }
  return a;
}
const xo = "9.8.0", It = -1, gt = "en-US", Lt = "", wn = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function Ro() {
  return {
    upper: (e, t) => t === "text" && F(e) ? e.toUpperCase() : t === "vnode" && X(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && F(e) ? e.toLowerCase() : t === "vnode" && X(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && F(e) ? wn(e) : t === "vnode" && X(e) && "__v_isVNode" in e ? wn(e.children) : e
  };
}
let fr;
function kn(e) {
  fr = e;
}
let dr;
function Mo(e) {
  dr = e;
}
let mr;
function Fo(e) {
  mr = e;
}
let pr = null;
const Pn = (e) => {
  pr = e;
}, Uo = () => pr;
let Dn = 0;
function $o(e = {}) {
  const t = Q(e.onWarn) ? e.onWarn : Ue, n = F(e.version) ? e.version : xo, a = F(e.locale) || Q(e.locale) ? e.locale : gt, o = Q(a) ? gt : a, r = re(e.fallbackLocale) || B(e.fallbackLocale) || F(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : o, i = B(e.messages) ? e.messages : { [o]: {} }, u = B(e.datetimeFormats) ? e.datetimeFormats : { [o]: {} }, l = B(e.numberFormats) ? e.numberFormats : { [o]: {} }, c = ue({}, e.modifiers || {}, Ro()), d = e.pluralRules || {}, p = Q(e.missing) ? e.missing : null, m = q(e.missingWarn) || nt(e.missingWarn) ? e.missingWarn : !0, E = q(e.fallbackWarn) || nt(e.fallbackWarn) ? e.fallbackWarn : !0, h = !!e.fallbackFormat, T = !!e.unresolving, S = Q(e.postTranslation) ? e.postTranslation : null, _ = B(e.processor) ? e.processor : null, g = q(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, O = !!e.escapeParameter, v = Q(e.messageCompiler) ? e.messageCompiler : fr;
  process.env.NODE_ENV !== "production" && Q(e.messageCompiler) && Ia(Ke(fe.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const P = Q(e.messageResolver) ? e.messageResolver : dr || _o, C = Q(e.localeFallbacker) ? e.localeFallbacker : mr || ko, N = X(e.fallbackContext) ? e.fallbackContext : void 0, W = e, b = X(W.__datetimeFormatters) ? W.__datetimeFormatters : /* @__PURE__ */ new Map(), w = X(W.__numberFormatters) ? W.__numberFormatters : /* @__PURE__ */ new Map(), R = X(W.__meta) ? W.__meta : {};
  Dn++;
  const I = {
    version: n,
    cid: Dn,
    locale: a,
    fallbackLocale: r,
    messages: i,
    modifiers: c,
    pluralRules: d,
    missing: p,
    missingWarn: m,
    fallbackWarn: E,
    fallbackFormat: h,
    unresolving: T,
    postTranslation: S,
    processor: _,
    warnHtmlMessage: g,
    escapeParameter: O,
    messageCompiler: v,
    messageResolver: P,
    localeFallbacker: C,
    fallbackContext: N,
    onWarn: t,
    __meta: R
  };
  return I.datetimeFormats = u, I.numberFormats = l, I.__datetimeFormatters = b, I.__numberFormatters = w, process.env.NODE_ENV !== "production" && (I.__v_emitter = W.__v_emitter != null ? W.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && Ao(I, n, R), I;
}
function Ct(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function _r(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function rn(e, t, n, a, o) {
  const { missing: r, onWarn: i } = e;
  if (process.env.NODE_ENV !== "production") {
    const u = e.__v_emitter;
    u && u.emit("missing", {
      locale: n,
      key: t,
      type: o,
      groupId: `${o}:${t}`
    });
  }
  if (r !== null) {
    const u = r(e, n, t, o);
    return F(u) ? u : t;
  } else
    return process.env.NODE_ENV !== "production" && _r(a, t) && i(Ke(fe.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function lt(e, t, n) {
  const a = e;
  a.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function Mt(e) {
  return (n) => Vo(n, e);
}
function Vo(e, t) {
  const n = t.b || t.body;
  if ((n.t || n.type) === 1) {
    const a = n, o = a.c || a.cases;
    return e.plural(o.reduce((r, i) => [
      ...r,
      xn(e, i)
    ], []));
  } else
    return xn(e, n);
}
function xn(e, t) {
  const n = t.s || t.static;
  if (n)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const a = (t.i || t.items).reduce((o, r) => [...o, Vt(e, r)], []);
    return e.normalize(a);
  }
}
function Vt(e, t) {
  const n = t.t || t.type;
  switch (n) {
    case 3:
      const a = t;
      return a.v || a.value;
    case 9:
      const o = t;
      return o.v || o.value;
    case 4:
      const r = t;
      return e.interpolate(e.named(r.k || r.key));
    case 5:
      const i = t;
      return e.interpolate(e.list(i.i != null ? i.i : i.index));
    case 6:
      const u = t, l = u.m || u.modifier;
      return e.linked(Vt(e, u.k || u.key), l ? Vt(e, l) : void 0, e.type);
    case 7:
      const c = t;
      return c.v || c.value;
    case 8:
      const d = t;
      return d.v || d.value;
    default:
      throw new Error(`unhandled node type on format message part: ${n}`);
  }
}
const Wo = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function gr(e, t) {
  t && Fa(e) && Ue(Zt(Wo, { source: e }));
}
const vr = (e) => e;
let Ze = /* @__PURE__ */ Object.create(null);
const ze = (e) => X(e) && (e.t === 0 || e.type === 0) && ("b" in e || "body" in e);
function br(e, t = {}) {
  let n = !1;
  const a = t.onError || Ra;
  return t.onError = (o) => {
    n = !0, a(o);
  }, { ...io(e, t), detectError: n };
}
const jo = /* @__NO_SIDE_EFFECTS__ */ (e, t) => {
  if (!F(e))
    throw Oe(ae.NOT_SUPPORT_NON_STRING_MESSAGE);
  {
    const n = q(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && gr(e, n);
    const o = (t.onCacheKey || vr)(e), r = Ze[o];
    if (r)
      return r;
    const { code: i, detectError: u } = br(e, t), l = new Function(`return ${i}`)();
    return u ? l : Ze[o] = l;
  }
};
function Go(e, t) {
  if (__INTLIFY_JIT_COMPILATION__ && !__INTLIFY_DROP_MESSAGE_COMPILER__ && F(e)) {
    const n = q(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && gr(e, n);
    const o = (t.onCacheKey || vr)(e), r = Ze[o];
    if (r)
      return r;
    const { ast: i, detectError: u } = br(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), l = Mt(i);
    return u ? l : Ze[o] = l;
  } else {
    if (process.env.NODE_ENV !== "production" && !ze(e))
      return Ue(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const n = e.cacheKey;
    if (n) {
      const a = Ze[n];
      return a || (Ze[n] = Mt(e));
    } else
      return Mt(e);
  }
}
const Rn = () => "", be = (e) => Q(e);
function Mn(e, ...t) {
  const { fallbackFormat: n, postTranslation: a, unresolving: o, messageCompiler: r, fallbackLocale: i, messages: u } = e, [l, c] = Wt(...t), d = q(c.missingWarn) ? c.missingWarn : e.missingWarn, p = q(c.fallbackWarn) ? c.fallbackWarn : e.fallbackWarn, m = q(c.escapeParameter) ? c.escapeParameter : e.escapeParameter, E = !!c.resolvedMessage, h = F(c.default) || q(c.default) ? q(c.default) ? r ? l : () => l : c.default : n ? r ? l : () => l : "", T = n || h !== "", S = nn(e, c);
  m && Ho(c);
  let [_, g, O] = E ? [
    l,
    S,
    u[S] || {}
  ] : hr(e, l, S, i, p, d), v = _, P = l;
  if (!E && !(F(v) || ze(v) || be(v)) && T && (v = h, P = v), !E && (!(F(v) || ze(v) || be(v)) || !F(g)))
    return o ? It : l;
  if (process.env.NODE_ENV !== "production" && F(v) && e.messageCompiler == null)
    return Ue(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${l}'.`), l;
  let C = !1;
  const N = () => {
    C = !0;
  }, W = be(v) ? v : Er(e, l, g, v, P, N);
  if (C)
    return v;
  const b = zo(e, g, O, c), w = To(b), R = Bo(e, W, w), I = a ? a(R, l) : R;
  if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const x = {
      timestamp: Date.now(),
      key: F(l) ? l : be(v) ? v.key : "",
      locale: g || (be(v) ? v.locale : ""),
      format: F(v) ? v : be(v) ? v.source : "",
      message: I
    };
    x.meta = ue({}, e.__meta, {}), So(x);
  }
  return I;
}
function Ho(e) {
  re(e.list) ? e.list = e.list.map((t) => F(t) ? hn(t) : t) : X(e.named) && Object.keys(e.named).forEach((t) => {
    F(e.named[t]) && (e.named[t] = hn(e.named[t]));
  });
}
function hr(e, t, n, a, o, r) {
  const { messages: i, onWarn: u, messageResolver: l, localeFallbacker: c } = e, d = c(e, a, n);
  let p = {}, m, E = null, h = n, T = null;
  const S = "translate";
  for (let _ = 0; _ < d.length; _++) {
    if (m = T = d[_], process.env.NODE_ENV !== "production" && n !== m && Ct(o, t) && u(Ke(fe.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: m
    })), process.env.NODE_ENV !== "production" && n !== m) {
      const C = e.__v_emitter;
      C && C.emit("fallback", {
        type: S,
        key: t,
        from: h,
        to: T,
        groupId: `${S}:${t}`
      });
    }
    p = i[m] || {};
    let g = null, O, v;
    if (process.env.NODE_ENV !== "production" && Fe && (g = window.performance.now(), O = "intlify-message-resolve-start", v = "intlify-message-resolve-end", pe && pe(O)), (E = l(p, t)) === null && (E = p[t]), process.env.NODE_ENV !== "production" && Fe) {
      const C = window.performance.now(), N = e.__v_emitter;
      N && g && E && N.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: E,
        time: C - g,
        groupId: `${S}:${t}`
      }), O && v && pe && Ye && (pe(v), Ye("intlify message resolve", O, v));
    }
    if (F(E) || ze(E) || be(E))
      break;
    const P = rn(
      e,
      // eslint-disable-line @typescript-eslint/no-explicit-any
      t,
      m,
      r,
      S
    );
    P !== t && (E = P), h = T;
  }
  return [E, m, p];
}
function Er(e, t, n, a, o, r) {
  const { messageCompiler: i, warnHtmlMessage: u } = e;
  if (be(a)) {
    const m = a;
    return m.locale = m.locale || n, m.key = m.key || t, m;
  }
  if (i == null) {
    const m = () => a;
    return m.locale = n, m.key = t, m;
  }
  let l = null, c, d;
  process.env.NODE_ENV !== "production" && Fe && (l = window.performance.now(), c = "intlify-message-compilation-start", d = "intlify-message-compilation-end", pe && pe(c));
  const p = i(a, Yo(e, n, o, a, u, r));
  if (process.env.NODE_ENV !== "production" && Fe) {
    const m = window.performance.now(), E = e.__v_emitter;
    E && l && E.emit("message-compilation", {
      type: "message-compilation",
      message: a,
      time: m - l,
      groupId: `translate:${t}`
    }), c && d && pe && Ye && (pe(d), Ye("intlify message compilation", c, d));
  }
  return p.locale = n, p.key = t, p.source = a, p;
}
function Bo(e, t, n) {
  let a = null, o, r;
  process.env.NODE_ENV !== "production" && Fe && (a = window.performance.now(), o = "intlify-message-evaluation-start", r = "intlify-message-evaluation-end", pe && pe(o));
  const i = t(n);
  if (process.env.NODE_ENV !== "production" && Fe) {
    const u = window.performance.now(), l = e.__v_emitter;
    l && a && l.emit("message-evaluation", {
      type: "message-evaluation",
      value: i,
      time: u - a,
      groupId: `translate:${t.key}`
    }), o && r && pe && Ye && (pe(r), Ye("intlify message evaluation", o, r));
  }
  return i;
}
function Wt(...e) {
  const [t, n, a] = e, o = {};
  if (!F(t) && !se(t) && !be(t) && !ze(t))
    throw Oe(ae.INVALID_ARGUMENT);
  const r = se(t) ? String(t) : (be(t), t);
  return se(n) ? o.plural = n : F(n) ? o.default = n : B(n) && !St(n) ? o.named = n : re(n) && (o.list = n), se(a) ? o.plural = a : F(a) ? o.default = a : B(a) && ue(o, a), [r, o];
}
function Yo(e, t, n, a, o, r) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: o,
    onError: (i) => {
      if (r && r(i), process.env.NODE_ENV !== "production") {
        const u = Ko(a), l = `Message compilation error: ${i.message}`, c = i.location && u && Sa(u, i.location.start.offset, i.location.end.offset), d = e.__v_emitter;
        d && u && d.emit("compile-error", {
          message: u,
          error: i.message,
          start: i.location && i.location.start.offset,
          end: i.location && i.location.end.offset,
          groupId: `translate:${n}`
        }), console.error(c ? `${l}
${c}` : l);
      } else
        throw i;
    },
    onCacheKey: (i) => Ea(t, n, i)
  };
}
function Ko(e) {
  if (F(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function zo(e, t, n, a) {
  const { modifiers: o, pluralRules: r, messageResolver: i, fallbackLocale: u, fallbackWarn: l, missingWarn: c, fallbackContext: d } = e, m = {
    locale: t,
    modifiers: o,
    pluralRules: r,
    messages: (E) => {
      let h = i(n, E);
      if (h == null && d) {
        const [, , T] = hr(d, E, t, u, l, c);
        h = i(T, E);
      }
      if (F(h) || ze(h)) {
        let T = !1;
        const _ = Er(e, E, t, h, E, () => {
          T = !0;
        });
        return T ? Rn : _;
      } else
        return be(h) ? h : Rn;
    }
  };
  return e.processor && (m.processor = e.processor), a.list && (m.list = a.list), a.named && (m.named = a.named), se(a.plural) && (m.pluralIndex = a.plural), m;
}
const Fn = typeof Intl < "u", yr = {
  dateTimeFormat: Fn && typeof Intl.DateTimeFormat < "u",
  numberFormat: Fn && typeof Intl.NumberFormat < "u"
};
function Un(e, ...t) {
  const { datetimeFormats: n, unresolving: a, fallbackLocale: o, onWarn: r, localeFallbacker: i } = e, { __datetimeFormatters: u } = e;
  if (process.env.NODE_ENV !== "production" && !yr.dateTimeFormat)
    return r(Ke(fe.CANNOT_FORMAT_DATE)), Lt;
  const [l, c, d, p] = jt(...t), m = q(d.missingWarn) ? d.missingWarn : e.missingWarn, E = q(d.fallbackWarn) ? d.fallbackWarn : e.fallbackWarn, h = !!d.part, T = nn(e, d), S = i(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    o,
    T
  );
  if (!F(l) || l === "")
    return new Intl.DateTimeFormat(T, p).format(c);
  let _ = {}, g, O = null, v = T, P = null;
  const C = "datetime format";
  for (let b = 0; b < S.length; b++) {
    if (g = P = S[b], process.env.NODE_ENV !== "production" && T !== g && Ct(E, l) && r(Ke(fe.FALLBACK_TO_DATE_FORMAT, {
      key: l,
      target: g
    })), process.env.NODE_ENV !== "production" && T !== g) {
      const w = e.__v_emitter;
      w && w.emit("fallback", {
        type: C,
        key: l,
        from: v,
        to: P,
        groupId: `${C}:${l}`
      });
    }
    if (_ = n[g] || {}, O = _[l], B(O))
      break;
    rn(e, l, g, m, C), v = P;
  }
  if (!B(O) || !F(g))
    return a ? It : l;
  let N = `${g}__${l}`;
  St(p) || (N = `${N}__${JSON.stringify(p)}`);
  let W = u.get(N);
  return W || (W = new Intl.DateTimeFormat(g, ue({}, O, p)), u.set(N, W)), h ? W.formatToParts(c) : W.format(c);
}
const Or = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function jt(...e) {
  const [t, n, a, o] = e, r = {};
  let i = {}, u;
  if (F(t)) {
    const l = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!l)
      throw Oe(ae.INVALID_ISO_DATE_ARGUMENT);
    const c = l[3] ? l[3].trim().startsWith("T") ? `${l[1].trim()}${l[3].trim()}` : `${l[1].trim()}T${l[3].trim()}` : l[1].trim();
    u = new Date(c);
    try {
      u.toISOString();
    } catch {
      throw Oe(ae.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (Oa(t)) {
    if (isNaN(t.getTime()))
      throw Oe(ae.INVALID_DATE_ARGUMENT);
    u = t;
  } else if (se(t))
    u = t;
  else
    throw Oe(ae.INVALID_ARGUMENT);
  return F(n) ? r.key = n : B(n) && Object.keys(n).forEach((l) => {
    Or.includes(l) ? i[l] = n[l] : r[l] = n[l];
  }), F(a) ? r.locale = a : B(a) && (i = a), B(o) && (i = o), [r.key || "", u, r, i];
}
function $n(e, t, n) {
  const a = e;
  for (const o in n) {
    const r = `${t}__${o}`;
    a.__datetimeFormatters.has(r) && a.__datetimeFormatters.delete(r);
  }
}
function Vn(e, ...t) {
  const { numberFormats: n, unresolving: a, fallbackLocale: o, onWarn: r, localeFallbacker: i } = e, { __numberFormatters: u } = e;
  if (process.env.NODE_ENV !== "production" && !yr.numberFormat)
    return r(Ke(fe.CANNOT_FORMAT_NUMBER)), Lt;
  const [l, c, d, p] = Gt(...t), m = q(d.missingWarn) ? d.missingWarn : e.missingWarn, E = q(d.fallbackWarn) ? d.fallbackWarn : e.fallbackWarn, h = !!d.part, T = nn(e, d), S = i(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    o,
    T
  );
  if (!F(l) || l === "")
    return new Intl.NumberFormat(T, p).format(c);
  let _ = {}, g, O = null, v = T, P = null;
  const C = "number format";
  for (let b = 0; b < S.length; b++) {
    if (g = P = S[b], process.env.NODE_ENV !== "production" && T !== g && Ct(E, l) && r(Ke(fe.FALLBACK_TO_NUMBER_FORMAT, {
      key: l,
      target: g
    })), process.env.NODE_ENV !== "production" && T !== g) {
      const w = e.__v_emitter;
      w && w.emit("fallback", {
        type: C,
        key: l,
        from: v,
        to: P,
        groupId: `${C}:${l}`
      });
    }
    if (_ = n[g] || {}, O = _[l], B(O))
      break;
    rn(e, l, g, m, C), v = P;
  }
  if (!B(O) || !F(g))
    return a ? It : l;
  let N = `${g}__${l}`;
  St(p) || (N = `${N}__${JSON.stringify(p)}`);
  let W = u.get(N);
  return W || (W = new Intl.NumberFormat(g, ue({}, O, p)), u.set(N, W)), h ? W.formatToParts(c) : W.format(c);
}
const Nr = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function Gt(...e) {
  const [t, n, a, o] = e, r = {};
  let i = {};
  if (!se(t))
    throw Oe(ae.INVALID_ARGUMENT);
  const u = t;
  return F(n) ? r.key = n : B(n) && Object.keys(n).forEach((l) => {
    Nr.includes(l) ? i[l] = n[l] : r[l] = n[l];
  }), F(a) ? r.locale = a : B(a) && (i = a), B(o) && (i = o), [r.key || "", u, r, i];
}
function Wn(e, t, n) {
  const a = e;
  for (const o in n) {
    const r = `${t}__${o}`;
    a.__numberFormatters.has(r) && a.__numberFormatters.delete(r);
  }
}
lo();
/*!
  * vue-i18n v9.8.0
  * (c) 2023 kazuya kawaguchi
  * Released under the MIT License.
  */
const Xo = "9.8.0";
function qo() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (Ie().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (Ie().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (Ie().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Ie().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Ie().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const Tr = fe.__EXTEND_POINT__, De = en(Tr), ve = {
  FALLBACK_TO_ROOT: Tr,
  NOT_SUPPORTED_PRESERVE: De(),
  NOT_SUPPORTED_FORMATTER: De(),
  NOT_SUPPORTED_PRESERVE_DIRECTIVE: De(),
  NOT_SUPPORTED_GET_CHOICE_INDEX: De(),
  COMPONENT_NAME_LEGACY_COMPATIBLE: De(),
  NOT_FOUND_PARENT_SCOPE: De(),
  IGNORE_OBJ_FLATTEN: De(),
  NOTICE_DROP_ALLOW_COMPOSITION: De()
  // 17
}, Jo = {
  [ve.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [ve.NOT_SUPPORTED_PRESERVE]: "Not supported 'preserve'.",
  [ve.NOT_SUPPORTED_FORMATTER]: "Not supported 'formatter'.",
  [ve.NOT_SUPPORTED_PRESERVE_DIRECTIVE]: "Not supported 'preserveDirectiveContent'.",
  [ve.NOT_SUPPORTED_GET_CHOICE_INDEX]: "Not supported 'getChoiceIndex'.",
  [ve.COMPONENT_NAME_LEGACY_COMPATIBLE]: "Component name legacy compatible: '{name}' -> 'i18n'",
  [ve.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [ve.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  [ve.NOTICE_DROP_ALLOW_COMPOSITION]: "'allowComposition' option will be dropped in the next major version. For more information, please see 👉 https://tinyurl.com/2p97mcze"
};
function an(e, ...t) {
  return Zt(Jo[e], ...t);
}
const Lr = ae.__EXTEND_POINT__, de = en(Lr), ee = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: Lr,
  // legacy module errors
  INVALID_ARGUMENT: de(),
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: de(),
  NOT_INSTALLED: de(),
  NOT_AVAILABLE_IN_LEGACY_MODE: de(),
  // directive module errors
  REQUIRED_VALUE: de(),
  INVALID_VALUE: de(),
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: de(),
  NOT_INSTALLED_WITH_PROVIDE: de(),
  // unexpected error
  UNEXPECTED_ERROR: de(),
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: de(),
  // bridge support vue 2.x only
  BRIDGE_SUPPORT_VUE_2_ONLY: de(),
  // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
  MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: de(),
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: de(),
  // for enhancement
  __EXTEND_POINT__: de()
  // 40
};
function Me(e, ...t) {
  return ot(e, null, process.env.NODE_ENV !== "production" ? { messages: Qo, args: t } : void 0);
}
const Qo = {
  [ee.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [ee.INVALID_ARGUMENT]: "Invalid argument",
  [ee.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [ee.NOT_INSTALLED]: "Need to install with `app.use` function",
  [ee.UNEXPECTED_ERROR]: "Unexpected error",
  [ee.NOT_AVAILABLE_IN_LEGACY_MODE]: "Not available in legacy mode",
  [ee.REQUIRED_VALUE]: "Required in value: {0}",
  [ee.INVALID_VALUE]: "Invalid value",
  [ee.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [ee.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [ee.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [ee.BRIDGE_SUPPORT_VUE_2_ONLY]: "vue-i18n-bridge support Vue 2.x only",
  [ee.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION]: "Must define ‘i18n’ option or custom block in Composition API with using local scope in Legacy API mode",
  [ee.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, Ht = /* @__PURE__ */ we("__translateVNode"), Bt = /* @__PURE__ */ we("__datetimeParts"), Yt = /* @__PURE__ */ we("__numberParts"), Kt = /* @__PURE__ */ we("__enableEmitter"), zt = /* @__PURE__ */ we("__disableEmitter"), Zo = we("__setPluralRules"), Ar = /* @__PURE__ */ we("__injectWithOption"), Xt = /* @__PURE__ */ we("__dispose");
function vt(e) {
  if (!X(e))
    return e;
  for (const t in e)
    if (pt(e, t))
      if (!t.includes("."))
        X(e[t]) && vt(e[t]);
      else {
        const n = t.split("."), a = n.length - 1;
        let o = e, r = !1;
        for (let i = 0; i < a; i++) {
          if (n[i] in o || (o[n[i]] = {}), !X(o[n[i]])) {
            process.env.NODE_ENV !== "production" && Ue(an(ve.IGNORE_OBJ_FLATTEN, {
              key: n[i]
            })), r = !0;
            break;
          }
          o = o[n[i]];
        }
        r || (o[n[a]] = e[t], delete e[t]), X(o[n[a]]) && vt(o[n[a]]);
      }
  return e;
}
function on(e, t) {
  const { messages: n, __i18n: a, messageResolver: o, flatJson: r } = t, i = B(n) ? n : re(a) ? {} : { [e]: {} };
  if (re(a) && a.forEach((u) => {
    if ("locale" in u && "resource" in u) {
      const { locale: l, resource: c } = u;
      l ? (i[l] = i[l] || {}, dt(c, i[l])) : dt(c, i);
    } else
      F(u) && dt(JSON.parse(u), i);
  }), o == null && r)
    for (const u in i)
      pt(i, u) && vt(i[u]);
  return i;
}
function ei(e) {
  return e.type;
}
function ti(e, t, n) {
  let a = X(t.messages) ? t.messages : {};
  "__i18nGlobal" in n && (a = on(e.locale.value, {
    messages: a,
    __i18n: n.__i18nGlobal
  }));
  const o = Object.keys(a);
  o.length && o.forEach((r) => {
    e.mergeLocaleMessage(r, a[r]);
  });
  {
    if (X(t.datetimeFormats)) {
      const r = Object.keys(t.datetimeFormats);
      r.length && r.forEach((i) => {
        e.mergeDateTimeFormat(i, t.datetimeFormats[i]);
      });
    }
    if (X(t.numberFormats)) {
      const r = Object.keys(t.numberFormats);
      r.length && r.forEach((i) => {
        e.mergeNumberFormat(i, t.numberFormats[i]);
      });
    }
  }
}
function jn(e) {
  return sa(ua, null, e, 0);
}
const Gn = () => [], ni = () => !1;
let Hn = 0;
function Bn(e) {
  return (t, n, a, o) => e(n, a, At() || void 0, o);
}
function ri(e = {}, t) {
  const { __root: n, __injectWithOption: a } = e, o = n === void 0, r = e.flatJson;
  let i = q(e.inheritLocale) ? e.inheritLocale : !0;
  const u = Z(
    // prettier-ignore
    n && i ? n.locale.value : F(e.locale) ? e.locale : gt
  ), l = Z(
    // prettier-ignore
    n && i ? n.fallbackLocale.value : F(e.fallbackLocale) || re(e.fallbackLocale) || B(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : u.value
  ), c = Z(on(u.value, e)), d = Z(B(e.datetimeFormats) ? e.datetimeFormats : { [u.value]: {} }), p = Z(B(e.numberFormats) ? e.numberFormats : { [u.value]: {} });
  let m = n ? n.missingWarn : q(e.missingWarn) || nt(e.missingWarn) ? e.missingWarn : !0, E = n ? n.fallbackWarn : q(e.fallbackWarn) || nt(e.fallbackWarn) ? e.fallbackWarn : !0, h = n ? n.fallbackRoot : q(e.fallbackRoot) ? e.fallbackRoot : !0, T = !!e.fallbackFormat, S = Q(e.missing) ? e.missing : null, _ = Q(e.missing) ? Bn(e.missing) : null, g = Q(e.postTranslation) ? e.postTranslation : null, O = n ? n.warnHtmlMessage : q(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, v = !!e.escapeParameter;
  const P = n ? n.modifiers : B(e.modifiers) ? e.modifiers : {};
  let C = e.pluralRules || n && n.pluralRules, N;
  N = (() => {
    o && Pn(null);
    const y = {
      version: Xo,
      locale: u.value,
      fallbackLocale: l.value,
      messages: c.value,
      modifiers: P,
      pluralRules: C,
      missing: _ === null ? void 0 : _,
      missingWarn: m,
      fallbackWarn: E,
      fallbackFormat: T,
      unresolving: !0,
      postTranslation: g === null ? void 0 : g,
      warnHtmlMessage: O,
      escapeParameter: v,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    y.datetimeFormats = d.value, y.numberFormats = p.value, y.__datetimeFormatters = B(N) ? N.__datetimeFormatters : void 0, y.__numberFormatters = B(N) ? N.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (y.__v_emitter = B(N) ? N.__v_emitter : void 0);
    const k = $o(y);
    return o && Pn(k), k;
  })(), lt(N, u.value, l.value);
  const b = le({
    get: () => u.value,
    set: (y) => {
      u.value = y, N.locale = u.value;
    }
  }), w = le({
    get: () => l.value,
    set: (y) => {
      l.value = y, N.fallbackLocale = l.value, lt(N, u.value, y);
    }
  }), R = le(() => c.value), I = /* @__PURE__ */ le(() => d.value), x = /* @__PURE__ */ le(() => p.value);
  function U() {
    return Q(g) ? g : null;
  }
  function D(y) {
    g = y, N.postTranslation = y;
  }
  function L() {
    return S;
  }
  function V(y) {
    y !== null && (_ = Bn(y)), S = y, N.missing = _;
  }
  function j(y, k) {
    return y !== "translate" || !k.resolvedMessage;
  }
  const $ = (y, k, z, te, We, Et) => {
    let qe;
    try {
      o || (N.fallbackContext = n ? Uo() : void 0), qe = y(N);
    } finally {
      o || (N.fallbackContext = void 0);
    }
    if (z !== "translate exists" && // for not `te` (e.g `t`)
    se(qe) && qe === It || z === "translate exists" && !qe) {
      const [je, oa] = k();
      if (process.env.NODE_ENV !== "production" && n && F(je) && j(z, oa) && (h && (Ct(E, je) || _r(m, je)) && Ue(an(ve.FALLBACK_TO_ROOT, {
        key: je,
        type: z
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: pn } = N;
        pn && h && pn.emit("fallback", {
          type: z,
          key: je,
          to: "global",
          groupId: `${z}:${je}`
        });
      }
      return n && h ? te(n) : We(je);
    } else {
      if (Et(qe))
        return qe;
      throw Me(ee.UNEXPECTED_RETURN_TYPE);
    }
  };
  function Y(...y) {
    return $((k) => Reflect.apply(Mn, null, [k, ...y]), () => Wt(...y), "translate", (k) => Reflect.apply(k.t, k, [...y]), (k) => k, (k) => F(k));
  }
  function Ne(...y) {
    const [k, z, te] = y;
    if (te && !X(te))
      throw Me(ee.INVALID_ARGUMENT);
    return Y(k, z, ue({ resolvedMessage: !0 }, te || {}));
  }
  function oe(...y) {
    return $((k) => Reflect.apply(Un, null, [k, ...y]), () => jt(...y), "datetime format", (k) => Reflect.apply(k.d, k, [...y]), () => Lt, (k) => F(k));
  }
  function he(...y) {
    return $((k) => Reflect.apply(Vn, null, [k, ...y]), () => Gt(...y), "number format", (k) => Reflect.apply(k.n, k, [...y]), () => Lt, (k) => F(k));
  }
  function Te(y) {
    return y.map((k) => F(k) || se(k) || q(k) ? jn(String(k)) : k);
  }
  const ie = {
    normalize: Te,
    interpolate: (y) => y,
    type: "vnode"
  };
  function me(...y) {
    return $(
      (k) => {
        let z;
        const te = k;
        try {
          te.processor = ie, z = Reflect.apply(Mn, null, [te, ...y]);
        } finally {
          te.processor = null;
        }
        return z;
      },
      () => Wt(...y),
      "translate",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (k) => k[Ht](...y),
      (k) => [jn(k)],
      (k) => re(k)
    );
  }
  function _e(...y) {
    return $(
      (k) => Reflect.apply(Vn, null, [k, ...y]),
      () => Gt(...y),
      "number format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (k) => k[Yt](...y),
      Gn,
      (k) => F(k) || re(k)
    );
  }
  function Le(...y) {
    return $(
      (k) => Reflect.apply(Un, null, [k, ...y]),
      () => jt(...y),
      "datetime format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (k) => k[Bt](...y),
      Gn,
      (k) => F(k) || re(k)
    );
  }
  function ge(y) {
    C = y, N.pluralRules = C;
  }
  function Ve(y, k) {
    return $(() => {
      if (!y)
        return !1;
      const z = F(k) ? k : u.value, te = f(z), We = N.messageResolver(te, y);
      return ze(We) || be(We) || F(We);
    }, () => [y], "translate exists", (z) => Reflect.apply(z.te, z, [y, k]), ni, (z) => q(z));
  }
  function it(y) {
    let k = null;
    const z = cr(N, l.value, u.value);
    for (let te = 0; te < z.length; te++) {
      const We = c.value[z[te]] || {}, Et = N.messageResolver(We, y);
      if (Et != null) {
        k = Et;
        break;
      }
    }
    return k;
  }
  function s(y) {
    const k = it(y);
    return k ?? (n ? n.tm(y) || {} : {});
  }
  function f(y) {
    return c.value[y] || {};
  }
  function A(y, k) {
    if (r) {
      const z = { [y]: k };
      for (const te in z)
        pt(z, te) && vt(z[te]);
      k = z[y];
    }
    c.value[y] = k, N.messages = c.value;
  }
  function M(y, k) {
    c.value[y] = c.value[y] || {};
    const z = { [y]: k };
    for (const te in z)
      pt(z, te) && vt(z[te]);
    k = z[y], dt(k, c.value[y]), N.messages = c.value;
  }
  function H(y) {
    return d.value[y] || {};
  }
  function K(y, k) {
    d.value[y] = k, N.datetimeFormats = d.value, $n(N, y, k);
  }
  function Ee(y, k) {
    d.value[y] = ue(d.value[y] || {}, k), N.datetimeFormats = d.value, $n(N, y, k);
  }
  function Ae(y) {
    return p.value[y] || {};
  }
  function ra(y, k) {
    p.value[y] = k, N.numberFormats = p.value, Wn(N, y, k);
  }
  function aa(y, k) {
    p.value[y] = ue(p.value[y] || {}, k), N.numberFormats = p.value, Wn(N, y, k);
  }
  Hn++, n && Fe && (Be(n.locale, (y) => {
    i && (u.value = y, N.locale = y, lt(N, u.value, l.value));
  }), Be(n.fallbackLocale, (y) => {
    i && (l.value = y, N.fallbackLocale = y, lt(N, u.value, l.value));
  }));
  const ne = {
    id: Hn,
    locale: b,
    fallbackLocale: w,
    get inheritLocale() {
      return i;
    },
    set inheritLocale(y) {
      i = y, y && n && (u.value = n.locale.value, l.value = n.fallbackLocale.value, lt(N, u.value, l.value));
    },
    get availableLocales() {
      return Object.keys(c.value).sort();
    },
    messages: R,
    get modifiers() {
      return P;
    },
    get pluralRules() {
      return C || {};
    },
    get isGlobal() {
      return o;
    },
    get missingWarn() {
      return m;
    },
    set missingWarn(y) {
      m = y, N.missingWarn = m;
    },
    get fallbackWarn() {
      return E;
    },
    set fallbackWarn(y) {
      E = y, N.fallbackWarn = E;
    },
    get fallbackRoot() {
      return h;
    },
    set fallbackRoot(y) {
      h = y;
    },
    get fallbackFormat() {
      return T;
    },
    set fallbackFormat(y) {
      T = y, N.fallbackFormat = T;
    },
    get warnHtmlMessage() {
      return O;
    },
    set warnHtmlMessage(y) {
      O = y, N.warnHtmlMessage = y;
    },
    get escapeParameter() {
      return v;
    },
    set escapeParameter(y) {
      v = y, N.escapeParameter = y;
    },
    t: Y,
    getLocaleMessage: f,
    setLocaleMessage: A,
    mergeLocaleMessage: M,
    getPostTranslationHandler: U,
    setPostTranslationHandler: D,
    getMissingHandler: L,
    setMissingHandler: V,
    [Zo]: ge
  };
  return ne.datetimeFormats = I, ne.numberFormats = x, ne.rt = Ne, ne.te = Ve, ne.tm = s, ne.d = oe, ne.n = he, ne.getDateTimeFormat = H, ne.setDateTimeFormat = K, ne.mergeDateTimeFormat = Ee, ne.getNumberFormat = Ae, ne.setNumberFormat = ra, ne.mergeNumberFormat = aa, ne[Ar] = a, ne[Ht] = me, ne[Bt] = Le, ne[Yt] = _e, process.env.NODE_ENV !== "production" && (ne[Kt] = (y) => {
    N.__v_emitter = y;
  }, ne[zt] = () => {
    N.__v_emitter = void 0;
  }), ne;
}
const ln = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function ai({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((a, o) => [
    ...a,
    // prettier-ignore
    ...o.type === tr ? o.children : [o]
  ], []) : t.reduce((n, a) => {
    const o = e[a];
    return o && (n[a] = o()), n;
  }, {});
}
function Sr(e) {
  return tr;
}
ue({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    validator: (e) => se(e) || !isNaN(e)
  }
}, ln);
function oi(e) {
  return re(e) && !F(e[0]);
}
function Ir(e, t, n, a) {
  const { slots: o, attrs: r } = t;
  return () => {
    const i = { part: !0 };
    let u = {};
    e.locale && (i.locale = e.locale), F(e.format) ? i.key = e.format : X(e.format) && (F(e.format.key) && (i.key = e.format.key), u = Object.keys(e.format).reduce((m, E) => n.includes(E) ? ue({}, m, { [E]: e.format[E] }) : m, {}));
    const l = a(e.value, i, u);
    let c = [i.key];
    re(l) ? c = l.map((m, E) => {
      const h = o[m.type], T = h ? h({ [m.type]: m.value, index: E, parts: l }) : [m.value];
      return oi(T) && (T[0].key = `${m.type}-${E}`), T;
    }) : F(l) && (c = [l]);
    const d = ue({}, r), p = F(e.tag) || X(e.tag) ? e.tag : Sr();
    return mt(p, d, c);
  };
}
ue({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, ln);
ue({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, ln);
function Yn(e, t) {
}
const ii = /* @__PURE__ */ we("global-vue-i18n");
function wt(e = {}) {
  const t = At();
  if (t == null)
    throw Me(ee.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw Me(ee.NOT_INSTALLED);
  const n = li(t), a = ui(n), o = ei(t), r = si(e, o);
  if (__VUE_I18N_LEGACY_API__ && n.mode === "legacy" && !e.__useComponent) {
    if (!n.allowComposition)
      throw Me(ee.NOT_AVAILABLE_IN_LEGACY_MODE);
    return mi(t, r, a, e);
  }
  if (r === "global")
    return ti(a, e, o), a;
  if (r === "parent") {
    let l = ci(n, t, e.__useComponent);
    return l == null && (process.env.NODE_ENV !== "production" && Ue(an(ve.NOT_FOUND_PARENT_SCOPE)), l = a), l;
  }
  const i = n;
  let u = i.__getInstance(t);
  if (u == null) {
    const l = ue({}, e);
    "__i18n" in o && (l.__i18n = o.__i18n), a && (l.__root = a), u = ri(l), i.__composerExtend && (u[Xt] = i.__composerExtend(u)), di(i, t, u), i.__setInstance(t, u);
  }
  return u;
}
function li(e) {
  {
    const t = Qn(e.isCE ? ii : e.appContext.app.__VUE_I18N_SYMBOL__);
    if (!t)
      throw Me(e.isCE ? ee.NOT_INSTALLED_WITH_PROVIDE : ee.UNEXPECTED_ERROR);
    return t;
  }
}
function si(e, t) {
  return St(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function ui(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function ci(e, t, n = !1) {
  let a = null;
  const o = t.root;
  let r = fi(t, n);
  for (; r != null; ) {
    const i = e;
    if (e.mode === "composition")
      a = i.__getInstance(r);
    else if (__VUE_I18N_LEGACY_API__) {
      const u = i.__getInstance(r);
      u != null && (a = u.__composer, n && a && !a[Ar] && (a = null));
    }
    if (a != null || o === r)
      break;
    r = r.parent;
  }
  return a;
}
function fi(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function di(e, t, n) {
  let a = null;
  bt(() => {
    if ((process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && t.vnode.el) {
      t.vnode.el.__VUE_I18N__ = n, a = Ca();
      const o = n;
      o[Kt] && o[Kt](a), a.on("*", Yn);
    }
  }, t), Zn(() => {
    const o = n;
    (process.env.NODE_ENV !== "production" || __VUE_PROD_DEVTOOLS__) && t.vnode.el && t.vnode.el.__VUE_I18N__ && (a && a.off("*", Yn), o[zt] && o[zt](), delete t.vnode.el.__VUE_I18N__), e.__deleteInstance(t);
    const r = o[Xt];
    r && (r(), delete o[Xt]);
  }, t);
}
function mi(e, t, n, a = {}) {
  const o = t === "local", r = Jt(null);
  if (o && e.proxy && !(e.proxy.$options.i18n || e.proxy.$options.__i18n))
    throw Me(ee.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);
  const i = q(a.inheritLocale) ? a.inheritLocale : !F(a.locale), u = Z(
    // prettier-ignore
    !o || i ? n.locale.value : F(a.locale) ? a.locale : gt
  ), l = Z(
    // prettier-ignore
    !o || i ? n.fallbackLocale.value : F(a.fallbackLocale) || re(a.fallbackLocale) || B(a.fallbackLocale) || a.fallbackLocale === !1 ? a.fallbackLocale : u.value
  ), c = Z(on(u.value, a)), d = Z(B(a.datetimeFormats) ? a.datetimeFormats : { [u.value]: {} }), p = Z(B(a.numberFormats) ? a.numberFormats : { [u.value]: {} }), m = o ? n.missingWarn : q(a.missingWarn) || nt(a.missingWarn) ? a.missingWarn : !0, E = o ? n.fallbackWarn : q(a.fallbackWarn) || nt(a.fallbackWarn) ? a.fallbackWarn : !0, h = o ? n.fallbackRoot : q(a.fallbackRoot) ? a.fallbackRoot : !0, T = !!a.fallbackFormat, S = Q(a.missing) ? a.missing : null, _ = Q(a.postTranslation) ? a.postTranslation : null, g = o ? n.warnHtmlMessage : q(a.warnHtmlMessage) ? a.warnHtmlMessage : !0, O = !!a.escapeParameter, v = o ? n.modifiers : B(a.modifiers) ? a.modifiers : {}, P = a.pluralRules || o && n.pluralRules, C = le({
    get: () => r.value ? r.value.locale.value : u.value,
    set: (s) => {
      r.value && (r.value.locale.value = s), u.value = s;
    }
  }), N = le({
    get: () => r.value ? r.value.fallbackLocale.value : l.value,
    set: (s) => {
      r.value && (r.value.fallbackLocale.value = s), l.value = s;
    }
  }), W = le(() => r.value ? r.value.messages.value : c.value), b = le(() => d.value), w = le(() => p.value);
  function R() {
    return r.value ? r.value.getPostTranslationHandler() : _;
  }
  function I(s) {
    r.value && r.value.setPostTranslationHandler(s);
  }
  function x() {
    return r.value ? r.value.getMissingHandler() : S;
  }
  function U(s) {
    r.value && r.value.setMissingHandler(s);
  }
  function D(s) {
    return s();
  }
  function L(...s) {
    return r.value ? D(() => Reflect.apply(r.value.t, null, [...s])) : D(() => "");
  }
  function V(...s) {
    return r.value ? Reflect.apply(r.value.rt, null, [...s]) : "";
  }
  function j(...s) {
    return r.value ? D(() => Reflect.apply(r.value.d, null, [...s])) : D(() => "");
  }
  function $(...s) {
    return r.value ? D(() => Reflect.apply(r.value.n, null, [...s])) : D(() => "");
  }
  function Y(s) {
    return r.value ? r.value.tm(s) : {};
  }
  function Ne(s, f) {
    return r.value ? r.value.te(s, f) : !1;
  }
  function oe(s) {
    return r.value ? r.value.getLocaleMessage(s) : {};
  }
  function he(s, f) {
    r.value && (r.value.setLocaleMessage(s, f), c.value[s] = f);
  }
  function Te(s, f) {
    r.value && r.value.mergeLocaleMessage(s, f);
  }
  function ke(s) {
    return r.value ? r.value.getDateTimeFormat(s) : {};
  }
  function ie(s, f) {
    r.value && (r.value.setDateTimeFormat(s, f), d.value[s] = f);
  }
  function me(s, f) {
    r.value && r.value.mergeDateTimeFormat(s, f);
  }
  function _e(s) {
    return r.value ? r.value.getNumberFormat(s) : {};
  }
  function Le(s, f) {
    r.value && (r.value.setNumberFormat(s, f), p.value[s] = f);
  }
  function ge(s, f) {
    r.value && r.value.mergeNumberFormat(s, f);
  }
  const Ve = {
    get id() {
      return r.value ? r.value.id : -1;
    },
    locale: C,
    fallbackLocale: N,
    messages: W,
    datetimeFormats: b,
    numberFormats: w,
    get inheritLocale() {
      return r.value ? r.value.inheritLocale : i;
    },
    set inheritLocale(s) {
      r.value && (r.value.inheritLocale = s);
    },
    get availableLocales() {
      return r.value ? r.value.availableLocales : Object.keys(c.value);
    },
    get modifiers() {
      return r.value ? r.value.modifiers : v;
    },
    get pluralRules() {
      return r.value ? r.value.pluralRules : P;
    },
    get isGlobal() {
      return r.value ? r.value.isGlobal : !1;
    },
    get missingWarn() {
      return r.value ? r.value.missingWarn : m;
    },
    set missingWarn(s) {
      r.value && (r.value.missingWarn = s);
    },
    get fallbackWarn() {
      return r.value ? r.value.fallbackWarn : E;
    },
    set fallbackWarn(s) {
      r.value && (r.value.missingWarn = s);
    },
    get fallbackRoot() {
      return r.value ? r.value.fallbackRoot : h;
    },
    set fallbackRoot(s) {
      r.value && (r.value.fallbackRoot = s);
    },
    get fallbackFormat() {
      return r.value ? r.value.fallbackFormat : T;
    },
    set fallbackFormat(s) {
      r.value && (r.value.fallbackFormat = s);
    },
    get warnHtmlMessage() {
      return r.value ? r.value.warnHtmlMessage : g;
    },
    set warnHtmlMessage(s) {
      r.value && (r.value.warnHtmlMessage = s);
    },
    get escapeParameter() {
      return r.value ? r.value.escapeParameter : O;
    },
    set escapeParameter(s) {
      r.value && (r.value.escapeParameter = s);
    },
    t: L,
    getPostTranslationHandler: R,
    setPostTranslationHandler: I,
    getMissingHandler: x,
    setMissingHandler: U,
    rt: V,
    d: j,
    n: $,
    tm: Y,
    te: Ne,
    getLocaleMessage: oe,
    setLocaleMessage: he,
    mergeLocaleMessage: Te,
    getDateTimeFormat: ke,
    setDateTimeFormat: ie,
    mergeDateTimeFormat: me,
    getNumberFormat: _e,
    setNumberFormat: Le,
    mergeNumberFormat: ge
  };
  function it(s) {
    s.locale.value = u.value, s.fallbackLocale.value = l.value, Object.keys(c.value).forEach((f) => {
      s.mergeLocaleMessage(f, c.value[f]);
    }), Object.keys(d.value).forEach((f) => {
      s.mergeDateTimeFormat(f, d.value[f]);
    }), Object.keys(p.value).forEach((f) => {
      s.mergeNumberFormat(f, p.value[f]);
    }), s.escapeParameter = O, s.fallbackFormat = T, s.fallbackRoot = h, s.fallbackWarn = E, s.missingWarn = m, s.warnHtmlMessage = g;
  }
  return er(() => {
    if (e.proxy == null || e.proxy.$i18n == null)
      throw Me(ee.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
    const s = r.value = e.proxy.$i18n.__composer;
    t === "global" ? (u.value = s.locale.value, l.value = s.fallbackLocale.value, c.value = s.messages.value, d.value = s.datetimeFormats.value, p.value = s.numberFormats.value) : o && it(s);
  }), Ve;
}
qo();
__INTLIFY_JIT_COMPILATION__ ? kn(Go) : kn(jo);
Mo(go);
Fo(cr);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = Ie();
  e.__INTLIFY__ = !0, Lo(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
function kl(e) {
  const t = ba(), { t: n } = wt(), a = typeof document < "u", o = Z(a ? document.title : "");
  function r() {
    if (!e.meta.tabTitle && t.currentRoute.value.fullPath === e.fullPath) {
      console.warn("No tab title set for this route. If this is unintentional please set one on route.meta.tabTitle property", e.fullPath, e.meta);
      return;
    }
    if (a && document.title !== e.meta.tabTitle) {
      const i = e.meta.tabTitle;
      document.title = `Cluber - ${typeof i != "string" ? i : n(i)}`;
    } else
      document.title = o.value;
  }
  Be(e, () => r()), er(r);
}
function kt(e) {
  return ca() ? (fa(e), !0) : !1;
}
function ht(e) {
  return typeof e == "function" ? e() : da(e);
}
const Cr = typeof window < "u" && typeof document < "u", pi = Object.prototype.toString, _i = (e) => pi.call(e) === "[object Object]", gi = () => {
};
function vi(e, t) {
  function n(...a) {
    return new Promise((o, r) => {
      Promise.resolve(e(() => t.apply(this, a), { fn: t, thisArg: this, args: a })).then(o).catch(r);
    });
  }
  return n;
}
const wr = (e) => e();
function bi(e = wr) {
  const t = Z(!0);
  function n() {
    t.value = !1;
  }
  function a() {
    t.value = !0;
  }
  const o = (...r) => {
    t.value && e(...r);
  };
  return { isActive: rr(t), pause: n, resume: a, eventFilter: o };
}
function hi(e, t) {
  var n;
  if (typeof e == "number")
    return e + t;
  const a = ((n = e.match(/^-?[0-9]+\.?[0-9]*/)) == null ? void 0 : n[0]) || "", o = e.slice(a.length), r = Number.parseFloat(a) + t;
  return Number.isNaN(r) ? e : r + o;
}
function Ei(e) {
  return e || At();
}
function yi(e, t, n = {}) {
  const {
    eventFilter: a = wr,
    ...o
  } = n;
  return Be(
    e,
    vi(
      a,
      t
    ),
    o
  );
}
function Oi(e, t, n = {}) {
  const {
    eventFilter: a,
    ...o
  } = n, { eventFilter: r, pause: i, resume: u, isActive: l } = bi(a);
  return { stop: yi(
    e,
    t,
    {
      ...o,
      eventFilter: r
    }
  ), pause: i, resume: u, isActive: l };
}
function Ni(e, t = !0, n) {
  const a = Ei(n);
  a ? bt(e, a) : t ? e() : nr(e);
}
function kr(e) {
  var t;
  const n = ht(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const at = Cr ? window : void 0, Ti = Cr ? window.navigator : void 0;
function Kn(...e) {
  let t, n, a, o;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, a, o] = e, t = at) : [t, n, a, o] = e, !t)
    return gi;
  Array.isArray(n) || (n = [n]), Array.isArray(a) || (a = [a]);
  const r = [], i = () => {
    r.forEach((d) => d()), r.length = 0;
  }, u = (d, p, m, E) => (d.addEventListener(p, m, E), () => d.removeEventListener(p, m, E)), l = Be(
    () => [kr(t), ht(o)],
    ([d, p]) => {
      if (i(), !d)
        return;
      const m = _i(p) ? { ...p } : p;
      r.push(
        ...n.flatMap((E) => a.map((h) => u(d, E, h, m)))
      );
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    l(), i();
  };
  return kt(c), c;
}
function Li() {
  const e = Z(!1);
  return At() && bt(() => {
    e.value = !0;
  }), e;
}
function sn(e) {
  return Li(), le(() => !!e());
}
function st(e, t = {}) {
  const { window: n = at } = t, a = sn(() => n && "matchMedia" in n && typeof n.matchMedia == "function");
  let o;
  const r = Z(!1), i = (c) => {
    r.value = c.matches;
  }, u = () => {
    o && ("removeEventListener" in o ? o.removeEventListener("change", i) : o.removeListener(i));
  }, l = ma(() => {
    a.value && (u(), o = n.matchMedia(ht(e)), "addEventListener" in o ? o.addEventListener("change", i) : o.addListener(i), r.value = o.matches);
  });
  return kt(() => {
    l(), u(), o = void 0;
  }), r;
}
function Ai(e, t = {}) {
  function n(u, l) {
    let c = ht(e[u]);
    return l != null && (c = hi(c, l)), typeof c == "number" && (c = `${c}px`), c;
  }
  const { window: a = at } = t;
  function o(u) {
    return a ? a.matchMedia(u).matches : !1;
  }
  const r = (u) => st(() => `(min-width: ${n(u)})`, t), i = Object.keys(e).reduce((u, l) => (Object.defineProperty(u, l, {
    get: () => r(l),
    enumerable: !0,
    configurable: !0
  }), u), {});
  return Object.assign(i, {
    greater(u) {
      return st(() => `(min-width: ${n(u, 0.1)})`, t);
    },
    greaterOrEqual: r,
    smaller(u) {
      return st(() => `(max-width: ${n(u, -0.1)})`, t);
    },
    smallerOrEqual(u) {
      return st(() => `(max-width: ${n(u)})`, t);
    },
    between(u, l) {
      return st(() => `(min-width: ${n(u)}) and (max-width: ${n(l, -0.1)})`, t);
    },
    isGreater(u) {
      return o(`(min-width: ${n(u, 0.1)})`);
    },
    isGreaterOrEqual(u) {
      return o(`(min-width: ${n(u)})`);
    },
    isSmaller(u) {
      return o(`(max-width: ${n(u, -0.1)})`);
    },
    isSmallerOrEqual(u) {
      return o(`(max-width: ${n(u)})`);
    },
    isInBetween(u, l) {
      return o(`(min-width: ${n(u)}) and (max-width: ${n(l, -0.1)})`);
    },
    current() {
      const u = Object.keys(e).map((l) => [l, r(l)]);
      return le(() => u.filter(([, l]) => l.value).map(([l]) => l));
    }
  });
}
const Ot = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Nt = "__vueuse_ssr_handlers__", Si = /* @__PURE__ */ Ii();
function Ii() {
  return Nt in Ot || (Ot[Nt] = Ot[Nt] || {}), Ot[Nt];
}
function Ci(e, t) {
  return Si[e] || t;
}
function wi(e) {
  return e == null ? "any" : e instanceof Set ? "set" : e instanceof Map ? "map" : e instanceof Date ? "date" : typeof e == "boolean" ? "boolean" : typeof e == "string" ? "string" : typeof e == "object" ? "object" : Number.isNaN(e) ? "any" : "number";
}
const ki = {
  boolean: {
    read: (e) => e === "true",
    write: (e) => String(e)
  },
  object: {
    read: (e) => JSON.parse(e),
    write: (e) => JSON.stringify(e)
  },
  number: {
    read: (e) => Number.parseFloat(e),
    write: (e) => String(e)
  },
  any: {
    read: (e) => e,
    write: (e) => String(e)
  },
  string: {
    read: (e) => e,
    write: (e) => String(e)
  },
  map: {
    read: (e) => new Map(JSON.parse(e)),
    write: (e) => JSON.stringify(Array.from(e.entries()))
  },
  set: {
    read: (e) => new Set(JSON.parse(e)),
    write: (e) => JSON.stringify(Array.from(e))
  },
  date: {
    read: (e) => new Date(e),
    write: (e) => e.toISOString()
  }
}, zn = "vueuse-storage";
function Pi(e, t, n, a = {}) {
  var o;
  const {
    flush: r = "pre",
    deep: i = !0,
    listenToStorageChanges: u = !0,
    writeDefaults: l = !0,
    mergeDefaults: c = !1,
    shallow: d,
    window: p = at,
    eventFilter: m,
    onError: E = (b) => {
      console.error(b);
    },
    initOnMounted: h
  } = a, T = (d ? Jt : Z)(typeof t == "function" ? t() : t);
  if (!n)
    try {
      n = Ci("getDefaultStorage", () => {
        var b;
        return (b = at) == null ? void 0 : b.localStorage;
      })();
    } catch (b) {
      E(b);
    }
  if (!n)
    return T;
  const S = ht(t), _ = wi(S), g = (o = a.serializer) != null ? o : ki[_], { pause: O, resume: v } = Oi(
    T,
    () => P(T.value),
    { flush: r, deep: i, eventFilter: m }
  );
  return p && u && Ni(() => {
    Kn(p, "storage", W), Kn(p, zn, N), h && W();
  }), h || W(), T;
  function P(b) {
    try {
      if (b == null)
        n.removeItem(e);
      else {
        const w = g.write(b), R = n.getItem(e);
        R !== w && (n.setItem(e, w), p && p.dispatchEvent(new CustomEvent(zn, {
          detail: {
            key: e,
            oldValue: R,
            newValue: w,
            storageArea: n
          }
        })));
      }
    } catch (w) {
      E(w);
    }
  }
  function C(b) {
    const w = b ? b.newValue : n.getItem(e);
    if (w == null)
      return l && S != null && n.setItem(e, g.write(S)), S;
    if (!b && c) {
      const R = g.read(w);
      return typeof c == "function" ? c(R, S) : _ === "object" && !Array.isArray(R) ? { ...S, ...R } : R;
    } else
      return typeof w != "string" ? w : g.read(w);
  }
  function N(b) {
    W(b.detail);
  }
  function W(b) {
    if (!(b && b.storageArea !== n)) {
      if (b && b.key == null) {
        T.value = S;
        return;
      }
      if (!(b && b.key !== e)) {
        O();
        try {
          (b == null ? void 0 : b.newValue) !== g.write(T.value) && (T.value = C(b));
        } catch (w) {
          E(w);
        } finally {
          b ? nr(v) : v();
        }
      }
    }
  }
}
function Di(e, t, n = {}) {
  const { window: a = at, ...o } = n;
  let r;
  const i = sn(() => a && "MutationObserver" in a), u = () => {
    r && (r.disconnect(), r = void 0);
  }, l = Be(
    () => kr(e),
    (p) => {
      u(), i.value && a && p && (r = new MutationObserver(t), r.observe(p, o));
    },
    { immediate: !0 }
  ), c = () => r == null ? void 0 : r.takeRecords(), d = () => {
    u(), l();
  };
  return kt(d), {
    isSupported: i,
    stop: d,
    takeRecords: c
  };
}
function xi(e = {}) {
  const {
    enableHighAccuracy: t = !0,
    maximumAge: n = 3e4,
    timeout: a = 27e3,
    navigator: o = Ti,
    immediate: r = !0
  } = e, i = sn(() => o && "geolocation" in o), u = Z(null), l = Jt(null), c = Z({
    accuracy: 0,
    latitude: Number.POSITIVE_INFINITY,
    longitude: Number.POSITIVE_INFINITY,
    altitude: null,
    altitudeAccuracy: null,
    heading: null,
    speed: null
  });
  function d(h) {
    u.value = h.timestamp, c.value = h.coords, l.value = null;
  }
  let p;
  function m() {
    i.value && (p = o.geolocation.watchPosition(
      d,
      (h) => l.value = h,
      {
        enableHighAccuracy: t,
        maximumAge: n,
        timeout: a
      }
    ));
  }
  r && m();
  function E() {
    p && o && o.geolocation.clearWatch(p);
  }
  return kt(() => {
    E();
  }), {
    isSupported: i,
    coords: c,
    locatedAt: u,
    error: l,
    resume: m,
    pause: E
  };
}
function Pl(e, t) {
  return {
    storage: Pi("cluber", e, localStorage, {
      ...t
      // serializer: {
      //   read: (value: string) => {
      //     if (value) {
      //       const decrypted = useEncryption().decrypt(value)
      //       console.log('READ', value, decrypted)
      //       return decrypted ? JSON.parse(decrypted) : null
      //     }
      //     return null
      //   },
      //   write: (value: T) => {
      //     console.log('WRITE', value)
      //     return useEncryption().encrypt(JSON.stringify(unref(value)))
      //   },
      // },
    })
  };
}
const Ri = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric"
}, Mi = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit"
}, Fi = {
  month: "long"
}, Ui = {
  month: "numeric"
}, $i = {
  weekday: "long"
}, Vi = {
  weekday: "long",
  day: "numeric"
}, Wi = {
  weekday: "short",
  day: "numeric"
}, ji = {
  month: "short",
  day: "numeric"
}, Gi = {
  day: "numeric"
}, Hi = {
  weekday: "short",
  year: "numeric",
  month: "short",
  day: "numeric"
}, Xn = {
  hour: "2-digit",
  minute: "2-digit"
}, Pr = Z("UTC");
function Bi(e) {
  return e.includes("+") ? Pr.value : Intl.DateTimeFormat().resolvedOptions().timeZoneName;
}
function Dl(e) {
  function t(a, o) {
    const r = pa(a), i = o || Bi(a);
    return {
      full: () => r.toLocaleDateString(e, Ri),
      fullShort: () => r.toLocaleDateString(e, Hi),
      fullNumeric: () => r.toLocaleDateString(e, Mi),
      monthName: () => r.toLocaleDateString(e, Fi),
      monthNumber: () => r.toLocaleDateString(e, Ui),
      monthFullShort: () => r.toLocaleDateString(e, ji),
      dayName: () => r.toLocaleDateString(e, $i),
      dayNumber: () => r.toLocaleDateString(e, Gi),
      dayFull: () => r.toLocaleDateString(e, Vi),
      dayFullShort: () => r.toLocaleDateString(e, Wi),
      hour: () => r.toLocaleTimeString(e, {
        ...Xn,
        timeZone: i
      }),
      hourWithSeconds: () => r.toLocaleTimeString(e, {
        ...Xn,
        second: "2-digit",
        timeZone: i
      })
    };
  }
  function n(a) {
    Pr.value = a;
  }
  return {
    parseISODate: t,
    setGlobalUserTimezone: n
  };
}
const ut = Z(), ct = Z(), qn = ft.createHash("sha256").update(String(ga())).digest("base64").substring(0, 32);
function xl() {
  function e(o) {
    if (!ut.value || !ct.value || !o)
      return "";
    const r = ft.createCipheriv(ct.value, qn, ut.value);
    let i = r.update(o, "utf-8", "hex");
    return i += r.final("hex"), i;
  }
  function t(o) {
    if (!ut.value || !ct.value || !o)
      return "";
    const r = ft.createDecipheriv(ct.value, qn, ut.value);
    let i = r.update(o, "hex", "utf-8");
    return i += r.final("utf-8"), i;
  }
  function n() {
    return `${ft.randomBytes(32).toString("hex")}_${ft.randomBytes(16).toString("hex")}`;
  }
  function a({ initiVector: o, algorithm: r }) {
    ut.value = o, ct.value = r;
  }
  return {
    encrypt: e,
    decrypt: t,
    generateKey: n,
    setEncryptionConfig: a
  };
}
const Yi = {
  multiple: !1,
  accept: ["*"]
};
function Rl(e = {}) {
  const t = Z([]);
  let n;
  const a = {
    ...Yi,
    ...e
  }, o = a.accept.map((u) => {
    const l = u.replace(/\//g, "\\$&").replace("*", ".+");
    return new RegExp(l);
  });
  function r() {
    n && (n.value = "", n.click());
  }
  function i(u) {
    t.value = t.value.filter((l) => l !== u);
  }
  return bt(() => {
    document && (n = document.createElement("input"), n.type = "file", n.multiple = a.multiple, n.accept = a.accept.join(","), n.onchange = (u) => {
      const c = u.target.files, d = Array.from(c).filter((p) => o.some((m) => p.type.match(m)));
      t.value = a.multiple ? t.value.concat(d) : d;
    });
  }), Zn(() => {
    n == null || n.remove();
  }), {
    files: rr(t),
    open: r,
    remove: i
  };
}
function Ft(e, t) {
  const n = e.value.find((a) => a.types.includes(t));
  return {
    name: (n == null ? void 0 : n.address_components[0].long_name) || "",
    short_name: (n == null ? void 0 : n.address_components[0].short_name) || ""
  };
}
const Ki = "AIzaSyAJWkS9BG8zzka4Ia90SJ1Jxp7NMCAwbgc";
function Ml(e = Ki) {
  const {
    coords: t,
    error: n,
    resume: a,
    pause: o
  } = xi({ immediate: !0 }), r = Z([]), i = Z(), u = le(() => Ft(r, "country")), l = le(() => Ft(r, "neighborhood")), c = le(() => Ft(r, "locality")), d = le(() => Number.isFinite(t.value.latitude) && Number.isFinite(t.value.longitude));
  return Be(t, () => {
    if (!n.value && d.value) {
      const p = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${t.value.latitude},${t.value.longitude}&key=${e}`;
      fetch(p).then((m) => m.json()).then((m) => {
        r.value = m.results;
      }).catch((m) => {
        i.value = m;
      }), o();
    }
  }, { immediate: !0 }), {
    geodata: r,
    country: u,
    locality: c,
    neighborhood: l,
    resume: a,
    pause: o
  };
}
var zi = /* @__PURE__ */ ((e) => (e.SM = "540px", e.MD = "768px", e.LG = "1024px", e.XL = "1280px", e))(zi || {});
function Xi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Dr = {}, xr = {}, un = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(n) {
    if (n = `${n}`, n === "0")
      return "0";
    if (/^[+-]?(\d+|\d*\.\d+)(e[+-]?\d+)?(%|\w+)?$/.test(n))
      return n.replace(/^[+-]?/, (o) => o === "-" ? "" : "-");
    let a = [
      "var",
      "calc",
      "min",
      "max",
      "clamp"
    ];
    for (const o of a)
      if (n.includes(`${o}(`))
        return `calc(${n} * -1)`;
  }
})(un);
var Rr = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  const t = [
    "preflight",
    "container",
    "accessibility",
    "pointerEvents",
    "visibility",
    "position",
    "inset",
    "isolation",
    "zIndex",
    "order",
    "gridColumn",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRow",
    "gridRowStart",
    "gridRowEnd",
    "float",
    "clear",
    "margin",
    "boxSizing",
    "lineClamp",
    "display",
    "aspectRatio",
    "height",
    "maxHeight",
    "minHeight",
    "width",
    "minWidth",
    "maxWidth",
    "flex",
    "flexShrink",
    "flexGrow",
    "flexBasis",
    "tableLayout",
    "captionSide",
    "borderCollapse",
    "borderSpacing",
    "transformOrigin",
    "translate",
    "rotate",
    "skew",
    "scale",
    "transform",
    "animation",
    "cursor",
    "touchAction",
    "userSelect",
    "resize",
    "scrollSnapType",
    "scrollSnapAlign",
    "scrollSnapStop",
    "scrollMargin",
    "scrollPadding",
    "listStylePosition",
    "listStyleType",
    "listStyleImage",
    "appearance",
    "columns",
    "breakBefore",
    "breakInside",
    "breakAfter",
    "gridAutoColumns",
    "gridAutoFlow",
    "gridAutoRows",
    "gridTemplateColumns",
    "gridTemplateRows",
    "flexDirection",
    "flexWrap",
    "placeContent",
    "placeItems",
    "alignContent",
    "alignItems",
    "justifyContent",
    "justifyItems",
    "gap",
    "space",
    "divideWidth",
    "divideStyle",
    "divideColor",
    "divideOpacity",
    "placeSelf",
    "alignSelf",
    "justifySelf",
    "overflow",
    "overscrollBehavior",
    "scrollBehavior",
    "textOverflow",
    "hyphens",
    "whitespace",
    "wordBreak",
    "borderRadius",
    "borderWidth",
    "borderStyle",
    "borderColor",
    "borderOpacity",
    "backgroundColor",
    "backgroundOpacity",
    "backgroundImage",
    "gradientColorStops",
    "boxDecorationBreak",
    "backgroundSize",
    "backgroundAttachment",
    "backgroundClip",
    "backgroundPosition",
    "backgroundRepeat",
    "backgroundOrigin",
    "fill",
    "stroke",
    "strokeWidth",
    "objectFit",
    "objectPosition",
    "padding",
    "textAlign",
    "textIndent",
    "verticalAlign",
    "fontFamily",
    "fontSize",
    "fontWeight",
    "textTransform",
    "fontStyle",
    "fontVariantNumeric",
    "lineHeight",
    "letterSpacing",
    "textColor",
    "textOpacity",
    "textDecoration",
    "textDecorationColor",
    "textDecorationStyle",
    "textDecorationThickness",
    "textUnderlineOffset",
    "fontSmoothing",
    "placeholderColor",
    "placeholderOpacity",
    "caretColor",
    "accentColor",
    "opacity",
    "backgroundBlendMode",
    "mixBlendMode",
    "boxShadow",
    "boxShadowColor",
    "outlineStyle",
    "outlineWidth",
    "outlineOffset",
    "outlineColor",
    "ringWidth",
    "ringColor",
    "ringOpacity",
    "ringOffsetWidth",
    "ringOffsetColor",
    "blur",
    "brightness",
    "contrast",
    "dropShadow",
    "grayscale",
    "hueRotate",
    "invert",
    "saturate",
    "sepia",
    "filter",
    "backdropBlur",
    "backdropBrightness",
    "backdropContrast",
    "backdropGrayscale",
    "backdropHueRotate",
    "backdropInvert",
    "backdropOpacity",
    "backdropSaturate",
    "backdropSepia",
    "backdropFilter",
    "transitionProperty",
    "transitionDelay",
    "transitionDuration",
    "transitionTimingFunction",
    "willChange",
    "content"
  ];
})(Rr);
var Mr = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(n, a) {
    return n === void 0 ? a : Array.isArray(n) ? n : [
      ...new Set(a.filter((r) => n !== !1 && n[r] !== !1).concat(Object.keys(n).filter((r) => n[r] !== !1)))
    ];
  }
})(Mr);
var Fr = {};
function Ur() {
  throw new Error("setTimeout has not been defined");
}
function $r() {
  throw new Error("clearTimeout has not been defined");
}
var xe = Ur, Re = $r;
typeof Qt.setTimeout == "function" && (xe = setTimeout);
typeof Qt.clearTimeout == "function" && (Re = clearTimeout);
function Vr(e) {
  if (xe === setTimeout)
    return setTimeout(e, 0);
  if ((xe === Ur || !xe) && setTimeout)
    return xe = setTimeout, setTimeout(e, 0);
  try {
    return xe(e, 0);
  } catch {
    try {
      return xe.call(null, e, 0);
    } catch {
      return xe.call(this, e, 0);
    }
  }
}
function qi(e) {
  if (Re === clearTimeout)
    return clearTimeout(e);
  if ((Re === $r || !Re) && clearTimeout)
    return Re = clearTimeout, clearTimeout(e);
  try {
    return Re(e);
  } catch {
    try {
      return Re.call(null, e);
    } catch {
      return Re.call(this, e);
    }
  }
}
var Ce = [], et = !1, He, Tt = -1;
function Ji() {
  !et || !He || (et = !1, He.length ? Ce = He.concat(Ce) : Tt = -1, Ce.length && Wr());
}
function Wr() {
  if (!et) {
    var e = Vr(Ji);
    et = !0;
    for (var t = Ce.length; t; ) {
      for (He = Ce, Ce = []; ++Tt < t; )
        He && He[Tt].run();
      Tt = -1, t = Ce.length;
    }
    He = null, et = !1, qi(e);
  }
}
function Qi(e) {
  var t = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var n = 1; n < arguments.length; n++)
      t[n - 1] = arguments[n];
  Ce.push(new jr(e, t)), Ce.length === 1 && !et && Vr(Wr);
}
function jr(e, t) {
  this.fun = e, this.array = t;
}
jr.prototype.run = function() {
  this.fun.apply(null, this.array);
};
var Zi = "browser", el = "browser", tl = !0, nl = {}, rl = [], al = "", ol = {}, il = {}, ll = {};
function Xe() {
}
var sl = Xe, ul = Xe, cl = Xe, fl = Xe, dl = Xe, ml = Xe, pl = Xe;
function _l(e) {
  throw new Error("process.binding is not supported");
}
function gl() {
  return "/";
}
function vl(e) {
  throw new Error("process.chdir is not supported");
}
function bl() {
  return 0;
}
var Qe = Qt.performance || {}, hl = Qe.now || Qe.mozNow || Qe.msNow || Qe.oNow || Qe.webkitNow || function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
function El(e) {
  var t = hl.call(Qe) * 1e-3, n = Math.floor(t), a = Math.floor(t % 1 * 1e9);
  return e && (n = n - e[0], a = a - e[1], a < 0 && (n--, a += 1e9)), [n, a];
}
var yl = /* @__PURE__ */ new Date();
function Ol() {
  var e = /* @__PURE__ */ new Date(), t = e - yl;
  return t / 1e3;
}
var qt = {
  nextTick: Qi,
  title: Zi,
  browser: tl,
  env: nl,
  argv: rl,
  version: al,
  versions: ol,
  on: sl,
  addListener: ul,
  once: cl,
  off: fl,
  removeListener: dl,
  removeAllListeners: ml,
  emit: pl,
  binding: _l,
  cwd: gl,
  chdir: vl,
  umask: bl,
  hrtime: El,
  platform: el,
  release: il,
  config: ll,
  uptime: Ol
}, Pt = {}, cn = { exports: {} }, J = String, Gr = function() {
  return { isColorSupported: !1, reset: J, bold: J, dim: J, italic: J, underline: J, inverse: J, hidden: J, strikethrough: J, black: J, red: J, green: J, yellow: J, blue: J, magenta: J, cyan: J, white: J, gray: J, bgBlack: J, bgRed: J, bgGreen: J, bgYellow: J, bgBlue: J, bgMagenta: J, bgCyan: J, bgWhite: J };
};
cn.exports = Gr();
cn.exports.createColors = Gr;
var Hr = cn.exports;
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(l, c) {
    for (var d in c)
      Object.defineProperty(l, d, {
        enumerable: !0,
        get: c[d]
      });
  }
  t(e, {
    dim: function() {
      return i;
    },
    default: function() {
      return u;
    }
  });
  const n = /* @__PURE__ */ a(Hr);
  function a(l) {
    return l && l.__esModule ? l : {
      default: l
    };
  }
  let o = /* @__PURE__ */ new Set();
  function r(l, c, d) {
    typeof qt < "u" && qt.env.JEST_WORKER_ID || d && o.has(d) || (d && o.add(d), console.warn(""), c.forEach((p) => console.warn(l, "-", p)));
  }
  function i(l) {
    return n.default.dim(l);
  }
  const u = {
    info(l, c) {
      r(n.default.bold(n.default.cyan("info")), ...Array.isArray(l) ? [
        l
      ] : [
        c,
        l
      ]);
    },
    warn(l, c) {
      r(n.default.bold(n.default.yellow("warn")), ...Array.isArray(l) ? [
        l
      ] : [
        c,
        l
      ]);
    },
    risk(l, c) {
      r(n.default.bold(n.default.magenta("risk")), ...Array.isArray(l) ? [
        l
      ] : [
        c,
        l
      ]);
    }
  };
})(Pt);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return o;
    }
  });
  const t = /* @__PURE__ */ n(Pt);
  function n(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  function a({ version: r, from: i, to: u }) {
    t.default.warn(`${i}-color-renamed`, [
      `As of Tailwind CSS ${r}, \`${i}\` has been renamed to \`${u}\`.`,
      "Update your configuration file to silence this warning."
    ]);
  }
  const o = {
    inherit: "inherit",
    current: "currentColor",
    transparent: "transparent",
    black: "#000",
    white: "#fff",
    slate: {
      50: "#f8fafc",
      100: "#f1f5f9",
      200: "#e2e8f0",
      300: "#cbd5e1",
      400: "#94a3b8",
      500: "#64748b",
      600: "#475569",
      700: "#334155",
      800: "#1e293b",
      900: "#0f172a",
      950: "#020617"
    },
    gray: {
      50: "#f9fafb",
      100: "#f3f4f6",
      200: "#e5e7eb",
      300: "#d1d5db",
      400: "#9ca3af",
      500: "#6b7280",
      600: "#4b5563",
      700: "#374151",
      800: "#1f2937",
      900: "#111827",
      950: "#030712"
    },
    zinc: {
      50: "#fafafa",
      100: "#f4f4f5",
      200: "#e4e4e7",
      300: "#d4d4d8",
      400: "#a1a1aa",
      500: "#71717a",
      600: "#52525b",
      700: "#3f3f46",
      800: "#27272a",
      900: "#18181b",
      950: "#09090b"
    },
    neutral: {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#e5e5e5",
      300: "#d4d4d4",
      400: "#a3a3a3",
      500: "#737373",
      600: "#525252",
      700: "#404040",
      800: "#262626",
      900: "#171717",
      950: "#0a0a0a"
    },
    stone: {
      50: "#fafaf9",
      100: "#f5f5f4",
      200: "#e7e5e4",
      300: "#d6d3d1",
      400: "#a8a29e",
      500: "#78716c",
      600: "#57534e",
      700: "#44403c",
      800: "#292524",
      900: "#1c1917",
      950: "#0c0a09"
    },
    red: {
      50: "#fef2f2",
      100: "#fee2e2",
      200: "#fecaca",
      300: "#fca5a5",
      400: "#f87171",
      500: "#ef4444",
      600: "#dc2626",
      700: "#b91c1c",
      800: "#991b1b",
      900: "#7f1d1d",
      950: "#450a0a"
    },
    orange: {
      50: "#fff7ed",
      100: "#ffedd5",
      200: "#fed7aa",
      300: "#fdba74",
      400: "#fb923c",
      500: "#f97316",
      600: "#ea580c",
      700: "#c2410c",
      800: "#9a3412",
      900: "#7c2d12",
      950: "#431407"
    },
    amber: {
      50: "#fffbeb",
      100: "#fef3c7",
      200: "#fde68a",
      300: "#fcd34d",
      400: "#fbbf24",
      500: "#f59e0b",
      600: "#d97706",
      700: "#b45309",
      800: "#92400e",
      900: "#78350f",
      950: "#451a03"
    },
    yellow: {
      50: "#fefce8",
      100: "#fef9c3",
      200: "#fef08a",
      300: "#fde047",
      400: "#facc15",
      500: "#eab308",
      600: "#ca8a04",
      700: "#a16207",
      800: "#854d0e",
      900: "#713f12",
      950: "#422006"
    },
    lime: {
      50: "#f7fee7",
      100: "#ecfccb",
      200: "#d9f99d",
      300: "#bef264",
      400: "#a3e635",
      500: "#84cc16",
      600: "#65a30d",
      700: "#4d7c0f",
      800: "#3f6212",
      900: "#365314",
      950: "#1a2e05"
    },
    green: {
      50: "#f0fdf4",
      100: "#dcfce7",
      200: "#bbf7d0",
      300: "#86efac",
      400: "#4ade80",
      500: "#22c55e",
      600: "#16a34a",
      700: "#15803d",
      800: "#166534",
      900: "#14532d",
      950: "#052e16"
    },
    emerald: {
      50: "#ecfdf5",
      100: "#d1fae5",
      200: "#a7f3d0",
      300: "#6ee7b7",
      400: "#34d399",
      500: "#10b981",
      600: "#059669",
      700: "#047857",
      800: "#065f46",
      900: "#064e3b",
      950: "#022c22"
    },
    teal: {
      50: "#f0fdfa",
      100: "#ccfbf1",
      200: "#99f6e4",
      300: "#5eead4",
      400: "#2dd4bf",
      500: "#14b8a6",
      600: "#0d9488",
      700: "#0f766e",
      800: "#115e59",
      900: "#134e4a",
      950: "#042f2e"
    },
    cyan: {
      50: "#ecfeff",
      100: "#cffafe",
      200: "#a5f3fc",
      300: "#67e8f9",
      400: "#22d3ee",
      500: "#06b6d4",
      600: "#0891b2",
      700: "#0e7490",
      800: "#155e75",
      900: "#164e63",
      950: "#083344"
    },
    sky: {
      50: "#f0f9ff",
      100: "#e0f2fe",
      200: "#bae6fd",
      300: "#7dd3fc",
      400: "#38bdf8",
      500: "#0ea5e9",
      600: "#0284c7",
      700: "#0369a1",
      800: "#075985",
      900: "#0c4a6e",
      950: "#082f49"
    },
    blue: {
      50: "#eff6ff",
      100: "#dbeafe",
      200: "#bfdbfe",
      300: "#93c5fd",
      400: "#60a5fa",
      500: "#3b82f6",
      600: "#2563eb",
      700: "#1d4ed8",
      800: "#1e40af",
      900: "#1e3a8a",
      950: "#172554"
    },
    indigo: {
      50: "#eef2ff",
      100: "#e0e7ff",
      200: "#c7d2fe",
      300: "#a5b4fc",
      400: "#818cf8",
      500: "#6366f1",
      600: "#4f46e5",
      700: "#4338ca",
      800: "#3730a3",
      900: "#312e81",
      950: "#1e1b4b"
    },
    violet: {
      50: "#f5f3ff",
      100: "#ede9fe",
      200: "#ddd6fe",
      300: "#c4b5fd",
      400: "#a78bfa",
      500: "#8b5cf6",
      600: "#7c3aed",
      700: "#6d28d9",
      800: "#5b21b6",
      900: "#4c1d95",
      950: "#2e1065"
    },
    purple: {
      50: "#faf5ff",
      100: "#f3e8ff",
      200: "#e9d5ff",
      300: "#d8b4fe",
      400: "#c084fc",
      500: "#a855f7",
      600: "#9333ea",
      700: "#7e22ce",
      800: "#6b21a8",
      900: "#581c87",
      950: "#3b0764"
    },
    fuchsia: {
      50: "#fdf4ff",
      100: "#fae8ff",
      200: "#f5d0fe",
      300: "#f0abfc",
      400: "#e879f9",
      500: "#d946ef",
      600: "#c026d3",
      700: "#a21caf",
      800: "#86198f",
      900: "#701a75",
      950: "#4a044e"
    },
    pink: {
      50: "#fdf2f8",
      100: "#fce7f3",
      200: "#fbcfe8",
      300: "#f9a8d4",
      400: "#f472b6",
      500: "#ec4899",
      600: "#db2777",
      700: "#be185d",
      800: "#9d174d",
      900: "#831843",
      950: "#500724"
    },
    rose: {
      50: "#fff1f2",
      100: "#ffe4e6",
      200: "#fecdd3",
      300: "#fda4af",
      400: "#fb7185",
      500: "#f43f5e",
      600: "#e11d48",
      700: "#be123c",
      800: "#9f1239",
      900: "#881337",
      950: "#4c0519"
    },
    get lightBlue() {
      return a({
        version: "v2.2",
        from: "lightBlue",
        to: "sky"
      }), this.sky;
    },
    get warmGray() {
      return a({
        version: "v3.0",
        from: "warmGray",
        to: "stone"
      }), this.stone;
    },
    get trueGray() {
      return a({
        version: "v3.0",
        from: "trueGray",
        to: "neutral"
      }), this.neutral;
    },
    get coolGray() {
      return a({
        version: "v3.0",
        from: "coolGray",
        to: "gray"
      }), this.gray;
    },
    get blueGray() {
      return a({
        version: "v3.0",
        from: "blueGray",
        to: "slate"
      }), this.slate;
    }
  };
})(Fr);
var Br = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "defaults", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(n, ...a) {
    for (let i of a) {
      for (let u in i) {
        var o;
        !(n == null || (o = n.hasOwnProperty) === null || o === void 0) && o.call(n, u) || (n[u] = i[u]);
      }
      for (let u of Object.getOwnPropertySymbols(i)) {
        var r;
        !(n == null || (r = n.hasOwnProperty) === null || r === void 0) && r.call(n, u) || (n[u] = i[u]);
      }
    }
    return n;
  }
})(Br);
var Yr = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "toPath", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(n) {
    if (Array.isArray(n))
      return n;
    let a = n.split("[").length - 1, o = n.split("]").length - 1;
    if (a !== o)
      throw new Error(`Path is invalid. Has unbalanced brackets: ${n}`);
    return n.split(/\.(?![^\[]*\])|[\[\]]/g).filter(Boolean);
  }
})(Yr);
var Kr = {}, Dt = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(p, m) {
    for (var E in m)
      Object.defineProperty(p, E, {
        enumerable: !0,
        get: m[E]
      });
  }
  t(e, {
    flagEnabled: function() {
      return u;
    },
    issueFlagNotices: function() {
      return c;
    },
    default: function() {
      return d;
    }
  });
  const n = /* @__PURE__ */ o(Hr), a = /* @__PURE__ */ o(Pt);
  function o(p) {
    return p && p.__esModule ? p : {
      default: p
    };
  }
  let r = {
    optimizeUniversalDefaults: !1,
    generalizedModifiers: !0,
    get disableColorOpacityUtilitiesByDefault() {
      return !1;
    },
    get relativeContentPathsByDefault() {
      return !1;
    }
  }, i = {
    future: [
      "hoverOnlyWhenSupported",
      "respectDefaultRingColorOpacity",
      "disableColorOpacityUtilitiesByDefault",
      "relativeContentPathsByDefault"
    ],
    experimental: [
      "optimizeUniversalDefaults",
      "generalizedModifiers"
    ]
  };
  function u(p, m) {
    if (i.future.includes(m)) {
      var E, h, T;
      return p.future === "all" || ((T = (h = p == null || (E = p.future) === null || E === void 0 ? void 0 : E[m]) !== null && h !== void 0 ? h : r[m]) !== null && T !== void 0 ? T : !1);
    }
    if (i.experimental.includes(m)) {
      var S, _, g;
      return p.experimental === "all" || ((g = (_ = p == null || (S = p.experimental) === null || S === void 0 ? void 0 : S[m]) !== null && _ !== void 0 ? _ : r[m]) !== null && g !== void 0 ? g : !1);
    }
    return !1;
  }
  function l(p) {
    if (p.experimental === "all")
      return i.experimental;
    var m;
    return Object.keys((m = p == null ? void 0 : p.experimental) !== null && m !== void 0 ? m : {}).filter((E) => i.experimental.includes(E) && p.experimental[E]);
  }
  function c(p) {
    if (qt.env.JEST_WORKER_ID === void 0 && l(p).length > 0) {
      let m = l(p).map((E) => n.default.yellow(E)).join(", ");
      a.default.warn("experimental-flags-enabled", [
        `You have enabled experimental features: ${m}`,
        "Experimental features in Tailwind CSS are not covered by semver, may introduce breaking changes, and can change at any time."
      ]);
    }
  }
  const d = i;
})(Dt);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "normalizeConfig", {
    enumerable: !0,
    get: function() {
      return r;
    }
  });
  const t = Dt, n = /* @__PURE__ */ o(Pt);
  function a(i) {
    if (typeof WeakMap != "function")
      return null;
    var u = /* @__PURE__ */ new WeakMap(), l = /* @__PURE__ */ new WeakMap();
    return (a = function(c) {
      return c ? l : u;
    })(i);
  }
  function o(i, u) {
    if (!u && i && i.__esModule)
      return i;
    if (i === null || typeof i != "object" && typeof i != "function")
      return {
        default: i
      };
    var l = a(u);
    if (l && l.has(i))
      return l.get(i);
    var c = {}, d = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var p in i)
      if (p !== "default" && Object.prototype.hasOwnProperty.call(i, p)) {
        var m = d ? Object.getOwnPropertyDescriptor(i, p) : null;
        m && (m.get || m.set) ? Object.defineProperty(c, p, m) : c[p] = i[p];
      }
    return c.default = i, l && l.set(i, c), c;
  }
  function r(i) {
    if ((() => {
      if (i.purge || !i.content || !Array.isArray(i.content) && !(typeof i.content == "object" && i.content !== null))
        return !1;
      if (Array.isArray(i.content))
        return i.content.every((c) => typeof c == "string" ? !0 : !(typeof (c == null ? void 0 : c.raw) != "string" || c != null && c.extension && typeof (c == null ? void 0 : c.extension) != "string"));
      if (typeof i.content == "object" && i.content !== null) {
        if (Object.keys(i.content).some((c) => ![
          "files",
          "relative",
          "extract",
          "transform"
        ].includes(c)))
          return !1;
        if (Array.isArray(i.content.files)) {
          if (!i.content.files.every((c) => typeof c == "string" ? !0 : !(typeof (c == null ? void 0 : c.raw) != "string" || c != null && c.extension && typeof (c == null ? void 0 : c.extension) != "string")))
            return !1;
          if (typeof i.content.extract == "object") {
            for (let c of Object.values(i.content.extract))
              if (typeof c != "function")
                return !1;
          } else if (!(i.content.extract === void 0 || typeof i.content.extract == "function"))
            return !1;
          if (typeof i.content.transform == "object") {
            for (let c of Object.values(i.content.transform))
              if (typeof c != "function")
                return !1;
          } else if (!(i.content.transform === void 0 || typeof i.content.transform == "function"))
            return !1;
          if (typeof i.content.relative != "boolean" && typeof i.content.relative < "u")
            return !1;
        }
        return !0;
      }
      return !1;
    })() || n.default.warn("purge-deprecation", [
      "The `purge`/`content` options have changed in Tailwind CSS v3.0.",
      "Update your configuration file to eliminate this warning.",
      "https://tailwindcss.com/docs/upgrade-guide#configure-content-sources"
    ]), i.safelist = (() => {
      var c;
      let { content: d, purge: p, safelist: m } = i;
      return Array.isArray(m) ? m : Array.isArray(d == null ? void 0 : d.safelist) ? d.safelist : Array.isArray(p == null ? void 0 : p.safelist) ? p.safelist : Array.isArray(p == null || (c = p.options) === null || c === void 0 ? void 0 : c.safelist) ? p.options.safelist : [];
    })(), i.blocklist = (() => {
      let { blocklist: c } = i;
      if (Array.isArray(c)) {
        if (c.every((d) => typeof d == "string"))
          return c;
        n.default.warn("blocklist-invalid", [
          "The `blocklist` option must be an array of strings.",
          "https://tailwindcss.com/docs/content-configuration#discarding-classes"
        ]);
      }
      return [];
    })(), typeof i.prefix == "function")
      n.default.warn("prefix-function", [
        "As of Tailwind CSS v3.0, `prefix` cannot be a function.",
        "Update `prefix` in your configuration to be a string to eliminate this warning.",
        "https://tailwindcss.com/docs/upgrade-guide#prefix-cannot-be-a-function"
      ]), i.prefix = "";
    else {
      var l;
      i.prefix = (l = i.prefix) !== null && l !== void 0 ? l : "";
    }
    i.content = {
      relative: (() => {
        let { content: c } = i;
        return c != null && c.relative ? c.relative : (0, t.flagEnabled)(i, "relativeContentPathsByDefault");
      })(),
      files: (() => {
        let { content: c, purge: d } = i;
        return Array.isArray(d) ? d : Array.isArray(d == null ? void 0 : d.content) ? d.content : Array.isArray(c) ? c : Array.isArray(c == null ? void 0 : c.content) ? c.content : Array.isArray(c == null ? void 0 : c.files) ? c.files : [];
      })(),
      extract: (() => {
        let c = (() => {
          var m, E, h, T, S, _, g, O, v, P;
          return !((m = i.purge) === null || m === void 0) && m.extract ? i.purge.extract : !((E = i.content) === null || E === void 0) && E.extract ? i.content.extract : !((h = i.purge) === null || h === void 0 || (T = h.extract) === null || T === void 0) && T.DEFAULT ? i.purge.extract.DEFAULT : !((S = i.content) === null || S === void 0 || (_ = S.extract) === null || _ === void 0) && _.DEFAULT ? i.content.extract.DEFAULT : !((g = i.purge) === null || g === void 0 || (O = g.options) === null || O === void 0) && O.extractors ? i.purge.options.extractors : !((v = i.content) === null || v === void 0 || (P = v.options) === null || P === void 0) && P.extractors ? i.content.options.extractors : {};
        })(), d = {}, p = (() => {
          var m, E, h, T;
          if (!((m = i.purge) === null || m === void 0 || (E = m.options) === null || E === void 0) && E.defaultExtractor)
            return i.purge.options.defaultExtractor;
          if (!((h = i.content) === null || h === void 0 || (T = h.options) === null || T === void 0) && T.defaultExtractor)
            return i.content.options.defaultExtractor;
        })();
        if (p !== void 0 && (d.DEFAULT = p), typeof c == "function")
          d.DEFAULT = c;
        else if (Array.isArray(c))
          for (let { extensions: m, extractor: E } of c ?? [])
            for (let h of m)
              d[h] = E;
        else
          typeof c == "object" && c !== null && Object.assign(d, c);
        return d;
      })(),
      transform: (() => {
        let c = (() => {
          var p, m, E, h, T, S;
          return !((p = i.purge) === null || p === void 0) && p.transform ? i.purge.transform : !((m = i.content) === null || m === void 0) && m.transform ? i.content.transform : !((E = i.purge) === null || E === void 0 || (h = E.transform) === null || h === void 0) && h.DEFAULT ? i.purge.transform.DEFAULT : !((T = i.content) === null || T === void 0 || (S = T.transform) === null || S === void 0) && S.DEFAULT ? i.content.transform.DEFAULT : {};
        })(), d = {};
        return typeof c == "function" && (d.DEFAULT = c), typeof c == "object" && c !== null && Object.assign(d, c), d;
      })()
    };
    for (let c of i.content.files)
      if (typeof c == "string" && /{([^,]*?)}/g.test(c)) {
        n.default.warn("invalid-glob-braces", [
          `The glob pattern ${(0, n.dim)(c)} in your Tailwind CSS configuration is invalid.`,
          `Update it to ${(0, n.dim)(c.replace(/{([^,]*?)}/g, "$1"))} to silence this warning.`
        ]);
        break;
      }
    return i;
  }
})(Kr);
var zr = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(n) {
    if (Object.prototype.toString.call(n) !== "[object Object]")
      return !1;
    const a = Object.getPrototypeOf(n);
    return a === null || Object.getPrototypeOf(a) === null;
  }
})(zr);
var Xr = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "cloneDeep", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(n) {
    return Array.isArray(n) ? n.map((a) => t(a)) : typeof n == "object" && n !== null ? Object.fromEntries(Object.entries(n).map(([a, o]) => [
      a,
      t(o)
    ])) : n;
  }
})(Xr);
var qr = {}, Jr = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(n) {
    return n.replace(/\\,/g, "\\2c ");
  }
})(Jr);
var fn = {}, dn = {}, Qr = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  const t = {
    aliceblue: [
      240,
      248,
      255
    ],
    antiquewhite: [
      250,
      235,
      215
    ],
    aqua: [
      0,
      255,
      255
    ],
    aquamarine: [
      127,
      255,
      212
    ],
    azure: [
      240,
      255,
      255
    ],
    beige: [
      245,
      245,
      220
    ],
    bisque: [
      255,
      228,
      196
    ],
    black: [
      0,
      0,
      0
    ],
    blanchedalmond: [
      255,
      235,
      205
    ],
    blue: [
      0,
      0,
      255
    ],
    blueviolet: [
      138,
      43,
      226
    ],
    brown: [
      165,
      42,
      42
    ],
    burlywood: [
      222,
      184,
      135
    ],
    cadetblue: [
      95,
      158,
      160
    ],
    chartreuse: [
      127,
      255,
      0
    ],
    chocolate: [
      210,
      105,
      30
    ],
    coral: [
      255,
      127,
      80
    ],
    cornflowerblue: [
      100,
      149,
      237
    ],
    cornsilk: [
      255,
      248,
      220
    ],
    crimson: [
      220,
      20,
      60
    ],
    cyan: [
      0,
      255,
      255
    ],
    darkblue: [
      0,
      0,
      139
    ],
    darkcyan: [
      0,
      139,
      139
    ],
    darkgoldenrod: [
      184,
      134,
      11
    ],
    darkgray: [
      169,
      169,
      169
    ],
    darkgreen: [
      0,
      100,
      0
    ],
    darkgrey: [
      169,
      169,
      169
    ],
    darkkhaki: [
      189,
      183,
      107
    ],
    darkmagenta: [
      139,
      0,
      139
    ],
    darkolivegreen: [
      85,
      107,
      47
    ],
    darkorange: [
      255,
      140,
      0
    ],
    darkorchid: [
      153,
      50,
      204
    ],
    darkred: [
      139,
      0,
      0
    ],
    darksalmon: [
      233,
      150,
      122
    ],
    darkseagreen: [
      143,
      188,
      143
    ],
    darkslateblue: [
      72,
      61,
      139
    ],
    darkslategray: [
      47,
      79,
      79
    ],
    darkslategrey: [
      47,
      79,
      79
    ],
    darkturquoise: [
      0,
      206,
      209
    ],
    darkviolet: [
      148,
      0,
      211
    ],
    deeppink: [
      255,
      20,
      147
    ],
    deepskyblue: [
      0,
      191,
      255
    ],
    dimgray: [
      105,
      105,
      105
    ],
    dimgrey: [
      105,
      105,
      105
    ],
    dodgerblue: [
      30,
      144,
      255
    ],
    firebrick: [
      178,
      34,
      34
    ],
    floralwhite: [
      255,
      250,
      240
    ],
    forestgreen: [
      34,
      139,
      34
    ],
    fuchsia: [
      255,
      0,
      255
    ],
    gainsboro: [
      220,
      220,
      220
    ],
    ghostwhite: [
      248,
      248,
      255
    ],
    gold: [
      255,
      215,
      0
    ],
    goldenrod: [
      218,
      165,
      32
    ],
    gray: [
      128,
      128,
      128
    ],
    green: [
      0,
      128,
      0
    ],
    greenyellow: [
      173,
      255,
      47
    ],
    grey: [
      128,
      128,
      128
    ],
    honeydew: [
      240,
      255,
      240
    ],
    hotpink: [
      255,
      105,
      180
    ],
    indianred: [
      205,
      92,
      92
    ],
    indigo: [
      75,
      0,
      130
    ],
    ivory: [
      255,
      255,
      240
    ],
    khaki: [
      240,
      230,
      140
    ],
    lavender: [
      230,
      230,
      250
    ],
    lavenderblush: [
      255,
      240,
      245
    ],
    lawngreen: [
      124,
      252,
      0
    ],
    lemonchiffon: [
      255,
      250,
      205
    ],
    lightblue: [
      173,
      216,
      230
    ],
    lightcoral: [
      240,
      128,
      128
    ],
    lightcyan: [
      224,
      255,
      255
    ],
    lightgoldenrodyellow: [
      250,
      250,
      210
    ],
    lightgray: [
      211,
      211,
      211
    ],
    lightgreen: [
      144,
      238,
      144
    ],
    lightgrey: [
      211,
      211,
      211
    ],
    lightpink: [
      255,
      182,
      193
    ],
    lightsalmon: [
      255,
      160,
      122
    ],
    lightseagreen: [
      32,
      178,
      170
    ],
    lightskyblue: [
      135,
      206,
      250
    ],
    lightslategray: [
      119,
      136,
      153
    ],
    lightslategrey: [
      119,
      136,
      153
    ],
    lightsteelblue: [
      176,
      196,
      222
    ],
    lightyellow: [
      255,
      255,
      224
    ],
    lime: [
      0,
      255,
      0
    ],
    limegreen: [
      50,
      205,
      50
    ],
    linen: [
      250,
      240,
      230
    ],
    magenta: [
      255,
      0,
      255
    ],
    maroon: [
      128,
      0,
      0
    ],
    mediumaquamarine: [
      102,
      205,
      170
    ],
    mediumblue: [
      0,
      0,
      205
    ],
    mediumorchid: [
      186,
      85,
      211
    ],
    mediumpurple: [
      147,
      112,
      219
    ],
    mediumseagreen: [
      60,
      179,
      113
    ],
    mediumslateblue: [
      123,
      104,
      238
    ],
    mediumspringgreen: [
      0,
      250,
      154
    ],
    mediumturquoise: [
      72,
      209,
      204
    ],
    mediumvioletred: [
      199,
      21,
      133
    ],
    midnightblue: [
      25,
      25,
      112
    ],
    mintcream: [
      245,
      255,
      250
    ],
    mistyrose: [
      255,
      228,
      225
    ],
    moccasin: [
      255,
      228,
      181
    ],
    navajowhite: [
      255,
      222,
      173
    ],
    navy: [
      0,
      0,
      128
    ],
    oldlace: [
      253,
      245,
      230
    ],
    olive: [
      128,
      128,
      0
    ],
    olivedrab: [
      107,
      142,
      35
    ],
    orange: [
      255,
      165,
      0
    ],
    orangered: [
      255,
      69,
      0
    ],
    orchid: [
      218,
      112,
      214
    ],
    palegoldenrod: [
      238,
      232,
      170
    ],
    palegreen: [
      152,
      251,
      152
    ],
    paleturquoise: [
      175,
      238,
      238
    ],
    palevioletred: [
      219,
      112,
      147
    ],
    papayawhip: [
      255,
      239,
      213
    ],
    peachpuff: [
      255,
      218,
      185
    ],
    peru: [
      205,
      133,
      63
    ],
    pink: [
      255,
      192,
      203
    ],
    plum: [
      221,
      160,
      221
    ],
    powderblue: [
      176,
      224,
      230
    ],
    purple: [
      128,
      0,
      128
    ],
    rebeccapurple: [
      102,
      51,
      153
    ],
    red: [
      255,
      0,
      0
    ],
    rosybrown: [
      188,
      143,
      143
    ],
    royalblue: [
      65,
      105,
      225
    ],
    saddlebrown: [
      139,
      69,
      19
    ],
    salmon: [
      250,
      128,
      114
    ],
    sandybrown: [
      244,
      164,
      96
    ],
    seagreen: [
      46,
      139,
      87
    ],
    seashell: [
      255,
      245,
      238
    ],
    sienna: [
      160,
      82,
      45
    ],
    silver: [
      192,
      192,
      192
    ],
    skyblue: [
      135,
      206,
      235
    ],
    slateblue: [
      106,
      90,
      205
    ],
    slategray: [
      112,
      128,
      144
    ],
    slategrey: [
      112,
      128,
      144
    ],
    snow: [
      255,
      250,
      250
    ],
    springgreen: [
      0,
      255,
      127
    ],
    steelblue: [
      70,
      130,
      180
    ],
    tan: [
      210,
      180,
      140
    ],
    teal: [
      0,
      128,
      128
    ],
    thistle: [
      216,
      191,
      216
    ],
    tomato: [
      255,
      99,
      71
    ],
    turquoise: [
      64,
      224,
      208
    ],
    violet: [
      238,
      130,
      238
    ],
    wheat: [
      245,
      222,
      179
    ],
    white: [
      255,
      255,
      255
    ],
    whitesmoke: [
      245,
      245,
      245
    ],
    yellow: [
      255,
      255,
      0
    ],
    yellowgreen: [
      154,
      205,
      50
    ]
  };
})(Qr);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(h, T) {
    for (var S in T)
      Object.defineProperty(h, S, {
        enumerable: !0,
        get: T[S]
      });
  }
  t(e, {
    parseColor: function() {
      return m;
    },
    formatColor: function() {
      return E;
    }
  });
  const n = /* @__PURE__ */ a(Qr);
  function a(h) {
    return h && h.__esModule ? h : {
      default: h
    };
  }
  let o = /^#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i, r = /^#([a-f\d])([a-f\d])([a-f\d])([a-f\d])?$/i, i = /(?:\d+|\d*\.\d+)%?/, u = /(?:\s*,\s*|\s+)/, l = /\s*[,/]\s*/, c = /var\(--(?:[^ )]*?)(?:,(?:[^ )]*?|var\(--[^ )]*?\)))?\)/, d = new RegExp(`^(rgba?)\\(\\s*(${i.source}|${c.source})(?:${u.source}(${i.source}|${c.source}))?(?:${u.source}(${i.source}|${c.source}))?(?:${l.source}(${i.source}|${c.source}))?\\s*\\)$`), p = new RegExp(`^(hsla?)\\(\\s*((?:${i.source})(?:deg|rad|grad|turn)?|${c.source})(?:${u.source}(${i.source}|${c.source}))?(?:${u.source}(${i.source}|${c.source}))?(?:${l.source}(${i.source}|${c.source}))?\\s*\\)$`);
  function m(h, { loose: T = !1 } = {}) {
    var S, _;
    if (typeof h != "string")
      return null;
    if (h = h.trim(), h === "transparent")
      return {
        mode: "rgb",
        color: [
          "0",
          "0",
          "0"
        ],
        alpha: "0"
      };
    if (h in n.default)
      return {
        mode: "rgb",
        color: n.default[h].map((C) => C.toString())
      };
    let g = h.replace(r, (C, N, W, b, w) => [
      "#",
      N,
      N,
      W,
      W,
      b,
      b,
      w ? w + w : ""
    ].join("")).match(o);
    if (g !== null)
      return {
        mode: "rgb",
        color: [
          parseInt(g[1], 16),
          parseInt(g[2], 16),
          parseInt(g[3], 16)
        ].map((C) => C.toString()),
        alpha: g[4] ? (parseInt(g[4], 16) / 255).toString() : void 0
      };
    var O;
    let v = (O = h.match(d)) !== null && O !== void 0 ? O : h.match(p);
    if (v === null)
      return null;
    let P = [
      v[2],
      v[3],
      v[4]
    ].filter(Boolean).map((C) => C.toString());
    return P.length === 2 && P[0].startsWith("var(") ? {
      mode: v[1],
      color: [
        P[0]
      ],
      alpha: P[1]
    } : !T && P.length !== 3 || P.length < 3 && !P.some((C) => /^var\(.*?\)$/.test(C)) ? null : {
      mode: v[1],
      color: P,
      alpha: (S = v[5]) === null || S === void 0 || (_ = S.toString) === null || _ === void 0 ? void 0 : _.call(S)
    };
  }
  function E({ mode: h, color: T, alpha: S }) {
    let _ = S !== void 0;
    return h === "rgba" || h === "hsla" ? `${h}(${T.join(", ")}${_ ? `, ${S}` : ""})` : `${h}(${T.join(" ")}${_ ? ` / ${S}` : ""})`;
  }
})(dn);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(r, i) {
    for (var u in i)
      Object.defineProperty(r, u, {
        enumerable: !0,
        get: i[u]
      });
  }
  t(e, {
    withAlphaValue: function() {
      return a;
    },
    default: function() {
      return o;
    }
  });
  const n = dn;
  function a(r, i, u) {
    if (typeof r == "function")
      return r({
        opacityValue: i
      });
    let l = (0, n.parseColor)(r, {
      loose: !0
    });
    return l === null ? u : (0, n.formatColor)({
      ...l,
      alpha: i
    });
  }
  function o({ color: r, property: i, variable: u }) {
    let l = [].concat(i);
    if (typeof r == "function")
      return {
        [u]: "1",
        ...Object.fromEntries(l.map((d) => [
          d,
          r({
            opacityVariable: u,
            opacityValue: `var(${u})`
          })
        ]))
      };
    const c = (0, n.parseColor)(r);
    return c === null ? Object.fromEntries(l.map((d) => [
      d,
      r
    ])) : c.alpha !== void 0 ? Object.fromEntries(l.map((d) => [
      d,
      r
    ])) : {
      [u]: "1",
      ...Object.fromEntries(l.map((d) => [
        d,
        (0, n.formatColor)({
          ...c,
          alpha: `var(${u})`
        })
      ]))
    };
  }
})(fn);
var mn = {}, Zr = {}, xt = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "splitAtTopLevelOnly", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(n, a) {
    let o = [], r = [], i = 0, u = !1;
    for (let l = 0; l < n.length; l++) {
      let c = n[l];
      o.length === 0 && c === a[0] && !u && (a.length === 1 || n.slice(l, l + a.length) === a) && (r.push(n.slice(i, l)), i = l + a.length), u ? u = !1 : c === "\\" && (u = !0), c === "(" || c === "[" || c === "{" ? o.push(c) : (c === ")" && o[o.length - 1] === "(" || c === "]" && o[o.length - 1] === "[" || c === "}" && o[o.length - 1] === "{") && o.pop();
    }
    return r.push(n.slice(i)), r;
  }
})(xt);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(l, c) {
    for (var d in c)
      Object.defineProperty(l, d, {
        enumerable: !0,
        get: c[d]
      });
  }
  t(e, {
    parseBoxShadowValue: function() {
      return i;
    },
    formatBoxShadowValue: function() {
      return u;
    }
  });
  const n = xt;
  let a = /* @__PURE__ */ new Set([
    "inset",
    "inherit",
    "initial",
    "revert",
    "unset"
  ]), o = /\ +(?![^(]*\))/g, r = /^-?(\d+|\.\d+)(.*?)$/g;
  function i(l) {
    return (0, n.splitAtTopLevelOnly)(l, ",").map((d) => {
      let p = d.trim(), m = {
        raw: p
      }, E = p.split(o), h = /* @__PURE__ */ new Set();
      for (let T of E)
        r.lastIndex = 0, !h.has("KEYWORD") && a.has(T) ? (m.keyword = T, h.add("KEYWORD")) : r.test(T) ? h.has("X") ? h.has("Y") ? h.has("BLUR") ? h.has("SPREAD") || (m.spread = T, h.add("SPREAD")) : (m.blur = T, h.add("BLUR")) : (m.y = T, h.add("Y")) : (m.x = T, h.add("X")) : m.color ? (m.unknown || (m.unknown = []), m.unknown.push(T)) : m.color = T;
      return m.valid = m.x !== void 0 && m.y !== void 0, m;
    });
  }
  function u(l) {
    return l.map((c) => c.valid ? [
      c.keyword,
      c.x,
      c.y,
      c.blur,
      c.spread,
      c.color
    ].filter(Boolean).join(" ") : c.raw).join(", ");
  }
})(Zr);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(L, V) {
    for (var j in V)
      Object.defineProperty(L, j, {
        enumerable: !0,
        get: V[j]
      });
  }
  t(e, {
    normalize: function() {
      return l;
    },
    url: function() {
      return d;
    },
    number: function() {
      return p;
    },
    percentage: function() {
      return m;
    },
    length: function() {
      return T;
    },
    lineWidth: function() {
      return _;
    },
    shadow: function() {
      return g;
    },
    color: function() {
      return O;
    },
    image: function() {
      return v;
    },
    gradient: function() {
      return C;
    },
    position: function() {
      return W;
    },
    familyName: function() {
      return b;
    },
    genericName: function() {
      return R;
    },
    absoluteSize: function() {
      return x;
    },
    relativeSize: function() {
      return D;
    }
  });
  const n = dn, a = Zr, o = xt;
  let r = [
    "min",
    "max",
    "clamp",
    "calc"
  ];
  function i(L) {
    return r.some((V) => new RegExp(`^${V}\\(.*\\)`).test(L));
  }
  const u = /* @__PURE__ */ new Set([
    // Concrete properties
    "scroll-timeline-name",
    "timeline-scope",
    "view-timeline-name",
    "font-palette",
    // Shorthand properties
    "scroll-timeline",
    "animation-timeline",
    "view-timeline"
  ]);
  function l(L, V = null, j = !0) {
    let $ = V && u.has(V.property);
    return L.startsWith("--") && !$ ? `var(${L})` : L.includes("url(") ? L.split(/(url\(.*?\))/g).filter(Boolean).map((Y) => /^url\(.*?\)$/.test(Y) ? Y : l(Y, V, !1)).join("") : (L = L.replace(/([^\\])_+/g, (Y, Ne) => Ne + " ".repeat(Y.length - 1)).replace(/^_/g, " ").replace(/\\_/g, "_"), j && (L = L.trim()), L = c(L), L);
  }
  function c(L) {
    let V = [
      "theme"
    ], j = [
      "min-content",
      "max-content",
      "fit-content",
      // Env
      "safe-area-inset-top",
      "safe-area-inset-right",
      "safe-area-inset-bottom",
      "safe-area-inset-left",
      "titlebar-area-x",
      "titlebar-area-y",
      "titlebar-area-width",
      "titlebar-area-height",
      "keyboard-inset-top",
      "keyboard-inset-right",
      "keyboard-inset-bottom",
      "keyboard-inset-left",
      "keyboard-inset-width",
      "keyboard-inset-height"
    ];
    return L.replace(/(calc|min|max|clamp)\(.+\)/g, ($) => {
      let Y = "";
      function Ne() {
        let oe = Y.trimEnd();
        return oe[oe.length - 1];
      }
      for (let oe = 0; oe < $.length; oe++) {
        let he = function(ie) {
          return ie.split("").every((me, _e) => $[oe + _e] === me);
        }, Te = function(ie) {
          let me = 1 / 0;
          for (let Le of ie) {
            let ge = $.indexOf(Le, oe);
            ge !== -1 && ge < me && (me = ge);
          }
          let _e = $.slice(oe, me);
          return oe += _e.length - 1, _e;
        }, ke = $[oe];
        if (he("var"))
          Y += Te([
            ")",
            ","
          ]);
        else if (j.some((ie) => he(ie))) {
          let ie = j.find((me) => he(me));
          Y += ie, oe += ie.length - 1;
        } else
          V.some((ie) => he(ie)) ? Y += Te([
            ")"
          ]) : [
            "+",
            "-",
            "*",
            "/"
          ].includes(ke) && ![
            "(",
            "+",
            "-",
            "*",
            "/",
            ","
          ].includes(Ne()) ? Y += ` ${ke} ` : Y += ke;
      }
      return Y.replace(/\s+/g, " ");
    });
  }
  function d(L) {
    return L.startsWith("url(");
  }
  function p(L) {
    return !isNaN(Number(L)) || i(L);
  }
  function m(L) {
    return L.endsWith("%") && p(L.slice(0, -1)) || i(L);
  }
  let h = `(?:${[
    "cm",
    "mm",
    "Q",
    "in",
    "pc",
    "pt",
    "px",
    "em",
    "ex",
    "ch",
    "rem",
    "lh",
    "rlh",
    "vw",
    "vh",
    "vmin",
    "vmax",
    "vb",
    "vi",
    "svw",
    "svh",
    "lvw",
    "lvh",
    "dvw",
    "dvh",
    "cqw",
    "cqh",
    "cqi",
    "cqb",
    "cqmin",
    "cqmax"
  ].join("|")})`;
  function T(L) {
    return L === "0" || new RegExp(`^[+-]?[0-9]*.?[0-9]+(?:[eE][+-]?[0-9]+)?${h}$`).test(L) || i(L);
  }
  let S = /* @__PURE__ */ new Set([
    "thin",
    "medium",
    "thick"
  ]);
  function _(L) {
    return S.has(L);
  }
  function g(L) {
    let V = (0, a.parseBoxShadowValue)(l(L));
    for (let j of V)
      if (!j.valid)
        return !1;
    return !0;
  }
  function O(L) {
    let V = 0;
    return (0, o.splitAtTopLevelOnly)(L, "_").every(($) => ($ = l($), $.startsWith("var(") ? !0 : (0, n.parseColor)($, {
      loose: !0
    }) !== null ? (V++, !0) : !1)) ? V > 0 : !1;
  }
  function v(L) {
    let V = 0;
    return (0, o.splitAtTopLevelOnly)(L, ",").every(($) => ($ = l($), $.startsWith("var(") ? !0 : d($) || C($) || [
      "element(",
      "image(",
      "cross-fade(",
      "image-set("
    ].some((Y) => $.startsWith(Y)) ? (V++, !0) : !1)) ? V > 0 : !1;
  }
  let P = /* @__PURE__ */ new Set([
    "conic-gradient",
    "linear-gradient",
    "radial-gradient",
    "repeating-conic-gradient",
    "repeating-linear-gradient",
    "repeating-radial-gradient"
  ]);
  function C(L) {
    L = l(L);
    for (let V of P)
      if (L.startsWith(`${V}(`))
        return !0;
    return !1;
  }
  let N = /* @__PURE__ */ new Set([
    "center",
    "top",
    "right",
    "bottom",
    "left"
  ]);
  function W(L) {
    let V = 0;
    return (0, o.splitAtTopLevelOnly)(L, "_").every(($) => ($ = l($), $.startsWith("var(") ? !0 : N.has($) || T($) || m($) ? (V++, !0) : !1)) ? V > 0 : !1;
  }
  function b(L) {
    let V = 0;
    return (0, o.splitAtTopLevelOnly)(L, ",").every(($) => ($ = l($), $.startsWith("var(") ? !0 : $.includes(" ") && !/(['"])([^"']+)\1/g.test($) || /^\d/g.test($) ? !1 : (V++, !0))) ? V > 0 : !1;
  }
  let w = /* @__PURE__ */ new Set([
    "serif",
    "sans-serif",
    "monospace",
    "cursive",
    "fantasy",
    "system-ui",
    "ui-serif",
    "ui-sans-serif",
    "ui-monospace",
    "ui-rounded",
    "math",
    "emoji",
    "fangsong"
  ]);
  function R(L) {
    return w.has(L);
  }
  let I = /* @__PURE__ */ new Set([
    "xx-small",
    "x-small",
    "small",
    "medium",
    "large",
    "x-large",
    "x-large",
    "xxx-large"
  ]);
  function x(L) {
    return I.has(L);
  }
  let U = /* @__PURE__ */ new Set([
    "larger",
    "smaller"
  ]);
  function D(L) {
    return U.has(L);
  }
})(mn);
var ea = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "backgroundSize", {
    enumerable: !0,
    get: function() {
      return a;
    }
  });
  const t = mn, n = xt;
  function a(o) {
    let r = [
      "cover",
      "contain"
    ];
    return (0, n.splitAtTopLevelOnly)(o, ",").every((i) => {
      let u = (0, n.splitAtTopLevelOnly)(i, "_").filter(Boolean);
      return u.length === 1 && r.includes(u[0]) ? !0 : u.length !== 1 && u.length !== 2 ? !1 : u.every((l) => (0, t.length)(l) || (0, t.percentage)(l) || l === "auto");
    });
  }
})(ea);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  function t(b, w) {
    for (var R in w)
      Object.defineProperty(b, R, {
        enumerable: !0,
        get: w[R]
      });
  }
  t(e, {
    updateAllClasses: function() {
      return c;
    },
    asValue: function() {
      return m;
    },
    parseColorFormat: function() {
      return T;
    },
    asColor: function() {
      return _;
    },
    asLookupValue: function() {
      return g;
    },
    typeMap: function() {
      return v;
    },
    coerceValue: function() {
      return N;
    },
    getMatchingTypes: function() {
      return W;
    }
  });
  const n = /* @__PURE__ */ l(Jr), a = fn, o = mn, r = /* @__PURE__ */ l(un), i = ea, u = Dt;
  function l(b) {
    return b && b.__esModule ? b : {
      default: b
    };
  }
  function c(b, w) {
    b.walkClasses((R) => {
      R.value = w(R.value), R.raws && R.raws.value && (R.raws.value = (0, n.default)(R.raws.value));
    });
  }
  function d(b, w) {
    if (!E(b))
      return;
    let R = b.slice(1, -1);
    if (w(R))
      return (0, o.normalize)(R);
  }
  function p(b, w = {}, R) {
    let I = w[b];
    if (I !== void 0)
      return (0, r.default)(I);
    if (E(b)) {
      let x = d(b, R);
      return x === void 0 ? void 0 : (0, r.default)(x);
    }
  }
  function m(b, w = {}, { validate: R = () => !0 } = {}) {
    var I;
    let x = (I = w.values) === null || I === void 0 ? void 0 : I[b];
    return x !== void 0 ? x : w.supportsNegativeValues && b.startsWith("-") ? p(b.slice(1), w.values, R) : d(b, R);
  }
  function E(b) {
    return b.startsWith("[") && b.endsWith("]");
  }
  function h(b) {
    let w = b.lastIndexOf("/"), R = b.lastIndexOf("[", w), I = b.indexOf("]", w);
    return b[w - 1] === "]" || b[w + 1] === "[" || R !== -1 && I !== -1 && R < w && w < I && (w = b.lastIndexOf("/", R)), w === -1 || w === b.length - 1 ? [
      b,
      void 0
    ] : E(b) && !b.includes("]/[") ? [
      b,
      void 0
    ] : [
      b.slice(0, w),
      b.slice(w + 1)
    ];
  }
  function T(b) {
    if (typeof b == "string" && b.includes("<alpha-value>")) {
      let w = b;
      return ({ opacityValue: R = 1 }) => w.replace("<alpha-value>", R);
    }
    return b;
  }
  function S(b) {
    return (0, o.normalize)(b.slice(1, -1));
  }
  function _(b, w = {}, { tailwindConfig: R = {} } = {}) {
    var I;
    if (((I = w.values) === null || I === void 0 ? void 0 : I[b]) !== void 0) {
      var x;
      return T((x = w.values) === null || x === void 0 ? void 0 : x[b]);
    }
    let [U, D] = h(b);
    if (D !== void 0) {
      var L, V, j, $;
      let Y = ($ = (L = w.values) === null || L === void 0 ? void 0 : L[U]) !== null && $ !== void 0 ? $ : E(U) ? U.slice(1, -1) : void 0;
      return Y === void 0 ? void 0 : (Y = T(Y), E(D) ? (0, a.withAlphaValue)(Y, S(D)) : ((V = R.theme) === null || V === void 0 || (j = V.opacity) === null || j === void 0 ? void 0 : j[D]) === void 0 ? void 0 : (0, a.withAlphaValue)(Y, R.theme.opacity[D]));
    }
    return m(b, w, {
      validate: o.color
    });
  }
  function g(b, w = {}) {
    var R;
    return (R = w.values) === null || R === void 0 ? void 0 : R[b];
  }
  function O(b) {
    return (w, R) => m(w, R, {
      validate: b
    });
  }
  let v = {
    any: m,
    color: _,
    url: O(o.url),
    image: O(o.image),
    length: O(o.length),
    percentage: O(o.percentage),
    position: O(o.position),
    lookup: g,
    "generic-name": O(o.genericName),
    "family-name": O(o.familyName),
    number: O(o.number),
    "line-width": O(o.lineWidth),
    "absolute-size": O(o.absoluteSize),
    "relative-size": O(o.relativeSize),
    shadow: O(o.shadow),
    size: O(i.backgroundSize)
  }, P = Object.keys(v);
  function C(b, w) {
    let R = b.indexOf(w);
    return R === -1 ? [
      void 0,
      b
    ] : [
      b.slice(0, R),
      b.slice(R + 1)
    ];
  }
  function N(b, w, R, I) {
    if (R.values && w in R.values)
      for (let { type: U } of b ?? []) {
        let D = v[U](w, R, {
          tailwindConfig: I
        });
        if (D !== void 0)
          return [
            D,
            U,
            null
          ];
      }
    if (E(w)) {
      let U = w.slice(1, -1), [D, L] = C(U, ":");
      if (!/^[\w-_]+$/g.test(D))
        L = U;
      else if (D !== void 0 && !P.includes(D))
        return [];
      if (L.length > 0 && P.includes(D))
        return [
          m(`[${L}]`, R),
          D,
          null
        ];
    }
    let x = W(b, w, R, I);
    for (let U of x)
      return U;
    return [];
  }
  function* W(b, w, R, I) {
    let x = (0, u.flagEnabled)(I, "generalizedModifiers"), [U, D] = h(w);
    if (x && R.modifiers != null && (R.modifiers === "any" || typeof R.modifiers == "object" && (D && E(D) || D in R.modifiers)) || (U = w, D = void 0), D !== void 0 && U === "" && (U = "DEFAULT"), D !== void 0 && typeof R.modifiers == "object") {
      var V, j;
      let $ = (j = (V = R.modifiers) === null || V === void 0 ? void 0 : V[D]) !== null && j !== void 0 ? j : null;
      $ !== null ? D = $ : E(D) && (D = S(D));
    }
    for (let { type: $ } of b ?? []) {
      let Y = v[$](U, R, {
        tailwindConfig: I
      });
      Y !== void 0 && (yield [
        Y,
        $,
        D ?? null
      ]);
    }
  }
})(qr);
var ta = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return t;
    }
  });
  function t(n) {
    return typeof n == "function" ? n({}) : n;
  }
})(ta);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return R;
    }
  });
  const t = /* @__PURE__ */ E(un), n = /* @__PURE__ */ E(Rr), a = /* @__PURE__ */ E(Mr), o = /* @__PURE__ */ E(Fr), r = Br, i = Yr, u = Kr, l = /* @__PURE__ */ E(zr), c = Xr, d = qr, p = fn, m = /* @__PURE__ */ E(ta);
  function E(I) {
    return I && I.__esModule ? I : {
      default: I
    };
  }
  function h(I) {
    return typeof I == "function";
  }
  function T(I, ...x) {
    let U = x.pop();
    for (let D of x)
      for (let L in D) {
        let V = U(I[L], D[L]);
        V === void 0 ? (0, l.default)(I[L]) && (0, l.default)(D[L]) ? I[L] = T({}, I[L], D[L], U) : I[L] = D[L] : I[L] = V;
      }
    return I;
  }
  const S = {
    colors: o.default,
    negative(I) {
      return Object.keys(I).filter((x) => I[x] !== "0").reduce((x, U) => {
        let D = (0, t.default)(I[U]);
        return D !== void 0 && (x[`-${U}`] = D), x;
      }, {});
    },
    breakpoints(I) {
      return Object.keys(I).filter((x) => typeof I[x] == "string").reduce((x, U) => ({
        ...x,
        [`screen-${U}`]: I[U]
      }), {});
    }
  };
  function _(I, ...x) {
    return h(I) ? I(...x) : I;
  }
  function g(I) {
    return I.reduce((x, { extend: U }) => T(x, U, (D, L) => D === void 0 ? [
      L
    ] : Array.isArray(D) ? [
      L,
      ...D
    ] : [
      L,
      D
    ]), {});
  }
  function O(I) {
    return {
      ...I.reduce((x, U) => (0, r.defaults)(x, U), {}),
      // In order to resolve n config objects, we combine all of their `extend` properties
      // into arrays instead of objects so they aren't overridden.
      extend: g(I)
    };
  }
  function v(I, x) {
    if (Array.isArray(I) && (0, l.default)(I[0]))
      return I.concat(x);
    if (Array.isArray(x) && (0, l.default)(x[0]) && (0, l.default)(I))
      return [
        I,
        ...x
      ];
    if (Array.isArray(x))
      return x;
  }
  function P({ extend: I, ...x }) {
    return T(x, I, (U, D) => !h(U) && !D.some(h) ? T({}, U, ...D, v) : (L, V) => T({}, ...[
      U,
      ...D
    ].map((j) => _(j, L, V)), v));
  }
  function* C(I) {
    let x = (0, i.toPath)(I);
    if (x.length === 0 || (yield x, Array.isArray(I)))
      return;
    let U = /^(.*?)\s*\/\s*([^/]+)$/, D = I.match(U);
    if (D !== null) {
      let [, L, V] = D, j = (0, i.toPath)(L);
      j.alpha = V, yield j;
    }
  }
  function N(I) {
    const x = (U, D) => {
      for (const L of C(U)) {
        let V = 0, j = I;
        for (; j != null && V < L.length; )
          j = j[L[V++]], j = h(j) && (L.alpha === void 0 || V <= L.length - 1) ? j(x, S) : j;
        if (j !== void 0) {
          if (L.alpha !== void 0) {
            let $ = (0, d.parseColorFormat)(j);
            return (0, p.withAlphaValue)($, L.alpha, (0, m.default)($));
          }
          return (0, l.default)(j) ? (0, c.cloneDeep)(j) : j;
        }
      }
      return D;
    };
    return Object.assign(x, {
      theme: x,
      ...S
    }), Object.keys(I).reduce((U, D) => (U[D] = h(I[D]) ? I[D](x, S) : I[D], U), {});
  }
  function W(I) {
    let x = [];
    return I.forEach((U) => {
      x = [
        ...x,
        U
      ];
      var D;
      const L = (D = U == null ? void 0 : U.plugins) !== null && D !== void 0 ? D : [];
      L.length !== 0 && L.forEach((V) => {
        V.__isOptionsFunction && (V = V());
        var j;
        x = [
          ...x,
          ...W([
            (j = V == null ? void 0 : V.config) !== null && j !== void 0 ? j : {}
          ])
        ];
      });
    }), x;
  }
  function b(I) {
    return [
      ...I
    ].reduceRight((U, D) => h(D) ? D({
      corePlugins: U
    }) : (0, a.default)(D, U), n.default);
  }
  function w(I) {
    return [
      ...I
    ].reduceRight((U, D) => [
      ...U,
      ...D
    ], []);
  }
  function R(I) {
    let x = [
      ...W(I),
      {
        prefix: "",
        important: !1,
        separator: ":"
      }
    ];
    var U, D;
    return (0, u.normalizeConfig)((0, r.defaults)({
      theme: N(P(O(x.map((L) => (U = L == null ? void 0 : L.theme) !== null && U !== void 0 ? U : {})))),
      corePlugins: b(x.map((L) => L.corePlugins)),
      plugins: w(I.map((L) => (D = L == null ? void 0 : L.plugins) !== null && D !== void 0 ? D : []))
    }, ...x));
  }
})(xr);
var na = {}, Nl = {
  content: [],
  presets: [],
  darkMode: "media",
  // or 'class'
  theme: {
    accentColor: ({ theme: e }) => ({
      ...e("colors"),
      auto: "auto"
    }),
    animation: {
      none: "none",
      spin: "spin 1s linear infinite",
      ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
      pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
      bounce: "bounce 1s infinite"
    },
    aria: {
      busy: 'busy="true"',
      checked: 'checked="true"',
      disabled: 'disabled="true"',
      expanded: 'expanded="true"',
      hidden: 'hidden="true"',
      pressed: 'pressed="true"',
      readonly: 'readonly="true"',
      required: 'required="true"',
      selected: 'selected="true"'
    },
    aspectRatio: {
      auto: "auto",
      square: "1 / 1",
      video: "16 / 9"
    },
    backdropBlur: ({ theme: e }) => e("blur"),
    backdropBrightness: ({ theme: e }) => e("brightness"),
    backdropContrast: ({ theme: e }) => e("contrast"),
    backdropGrayscale: ({ theme: e }) => e("grayscale"),
    backdropHueRotate: ({ theme: e }) => e("hueRotate"),
    backdropInvert: ({ theme: e }) => e("invert"),
    backdropOpacity: ({ theme: e }) => e("opacity"),
    backdropSaturate: ({ theme: e }) => e("saturate"),
    backdropSepia: ({ theme: e }) => e("sepia"),
    backgroundColor: ({ theme: e }) => e("colors"),
    backgroundImage: {
      none: "none",
      "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
      "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
      "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
      "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
      "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
      "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
      "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
      "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
    },
    backgroundOpacity: ({ theme: e }) => e("opacity"),
    backgroundPosition: {
      bottom: "bottom",
      center: "center",
      left: "left",
      "left-bottom": "left bottom",
      "left-top": "left top",
      right: "right",
      "right-bottom": "right bottom",
      "right-top": "right top",
      top: "top"
    },
    backgroundSize: {
      auto: "auto",
      cover: "cover",
      contain: "contain"
    },
    blur: {
      0: "0",
      none: "0",
      sm: "4px",
      DEFAULT: "8px",
      md: "12px",
      lg: "16px",
      xl: "24px",
      "2xl": "40px",
      "3xl": "64px"
    },
    borderColor: ({ theme: e }) => ({
      ...e("colors"),
      DEFAULT: e("colors.gray.200", "currentColor")
    }),
    borderOpacity: ({ theme: e }) => e("opacity"),
    borderRadius: {
      none: "0px",
      sm: "0.125rem",
      DEFAULT: "0.25rem",
      md: "0.375rem",
      lg: "0.5rem",
      xl: "0.75rem",
      "2xl": "1rem",
      "3xl": "1.5rem",
      full: "9999px"
    },
    borderSpacing: ({ theme: e }) => ({
      ...e("spacing")
    }),
    borderWidth: {
      DEFAULT: "1px",
      0: "0px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    boxShadow: {
      sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
      "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
      inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
      none: "none"
    },
    boxShadowColor: ({ theme: e }) => e("colors"),
    brightness: {
      0: "0",
      50: ".5",
      75: ".75",
      90: ".9",
      95: ".95",
      100: "1",
      105: "1.05",
      110: "1.1",
      125: "1.25",
      150: "1.5",
      200: "2"
    },
    caretColor: ({ theme: e }) => e("colors"),
    colors: ({ colors: e }) => ({
      inherit: e.inherit,
      current: e.current,
      transparent: e.transparent,
      black: e.black,
      white: e.white,
      slate: e.slate,
      gray: e.gray,
      zinc: e.zinc,
      neutral: e.neutral,
      stone: e.stone,
      red: e.red,
      orange: e.orange,
      amber: e.amber,
      yellow: e.yellow,
      lime: e.lime,
      green: e.green,
      emerald: e.emerald,
      teal: e.teal,
      cyan: e.cyan,
      sky: e.sky,
      blue: e.blue,
      indigo: e.indigo,
      violet: e.violet,
      purple: e.purple,
      fuchsia: e.fuchsia,
      pink: e.pink,
      rose: e.rose
    }),
    columns: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      "3xs": "16rem",
      "2xs": "18rem",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem"
    },
    container: {},
    content: {
      none: "none"
    },
    contrast: {
      0: "0",
      50: ".5",
      75: ".75",
      100: "1",
      125: "1.25",
      150: "1.5",
      200: "2"
    },
    cursor: {
      auto: "auto",
      default: "default",
      pointer: "pointer",
      wait: "wait",
      text: "text",
      move: "move",
      help: "help",
      "not-allowed": "not-allowed",
      none: "none",
      "context-menu": "context-menu",
      progress: "progress",
      cell: "cell",
      crosshair: "crosshair",
      "vertical-text": "vertical-text",
      alias: "alias",
      copy: "copy",
      "no-drop": "no-drop",
      grab: "grab",
      grabbing: "grabbing",
      "all-scroll": "all-scroll",
      "col-resize": "col-resize",
      "row-resize": "row-resize",
      "n-resize": "n-resize",
      "e-resize": "e-resize",
      "s-resize": "s-resize",
      "w-resize": "w-resize",
      "ne-resize": "ne-resize",
      "nw-resize": "nw-resize",
      "se-resize": "se-resize",
      "sw-resize": "sw-resize",
      "ew-resize": "ew-resize",
      "ns-resize": "ns-resize",
      "nesw-resize": "nesw-resize",
      "nwse-resize": "nwse-resize",
      "zoom-in": "zoom-in",
      "zoom-out": "zoom-out"
    },
    divideColor: ({ theme: e }) => e("borderColor"),
    divideOpacity: ({ theme: e }) => e("borderOpacity"),
    divideWidth: ({ theme: e }) => e("borderWidth"),
    dropShadow: {
      sm: "0 1px 1px rgb(0 0 0 / 0.05)",
      DEFAULT: ["0 1px 2px rgb(0 0 0 / 0.1)", "0 1px 1px rgb(0 0 0 / 0.06)"],
      md: ["0 4px 3px rgb(0 0 0 / 0.07)", "0 2px 2px rgb(0 0 0 / 0.06)"],
      lg: ["0 10px 8px rgb(0 0 0 / 0.04)", "0 4px 3px rgb(0 0 0 / 0.1)"],
      xl: ["0 20px 13px rgb(0 0 0 / 0.03)", "0 8px 5px rgb(0 0 0 / 0.08)"],
      "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
      none: "0 0 #0000"
    },
    fill: ({ theme: e }) => ({
      none: "none",
      ...e("colors")
    }),
    flex: {
      1: "1 1 0%",
      auto: "1 1 auto",
      initial: "0 1 auto",
      none: "none"
    },
    flexBasis: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%"
    }),
    flexGrow: {
      0: "0",
      DEFAULT: "1"
    },
    flexShrink: {
      0: "0",
      DEFAULT: "1"
    },
    fontFamily: {
      sans: [
        "ui-sans-serif",
        "system-ui",
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        '"Noto Sans"',
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        '"Noto Color Emoji"'
      ],
      serif: ["ui-serif", "Georgia", "Cambria", '"Times New Roman"', "Times", "serif"],
      mono: [
        "ui-monospace",
        "SFMono-Regular",
        "Menlo",
        "Monaco",
        "Consolas",
        '"Liberation Mono"',
        '"Courier New"',
        "monospace"
      ]
    },
    fontSize: {
      xs: ["0.75rem", { lineHeight: "1rem" }],
      sm: ["0.875rem", { lineHeight: "1.25rem" }],
      base: ["1rem", { lineHeight: "1.5rem" }],
      lg: ["1.125rem", { lineHeight: "1.75rem" }],
      xl: ["1.25rem", { lineHeight: "1.75rem" }],
      "2xl": ["1.5rem", { lineHeight: "2rem" }],
      "3xl": ["1.875rem", { lineHeight: "2.25rem" }],
      "4xl": ["2.25rem", { lineHeight: "2.5rem" }],
      "5xl": ["3rem", { lineHeight: "1" }],
      "6xl": ["3.75rem", { lineHeight: "1" }],
      "7xl": ["4.5rem", { lineHeight: "1" }],
      "8xl": ["6rem", { lineHeight: "1" }],
      "9xl": ["8rem", { lineHeight: "1" }]
    },
    fontWeight: {
      thin: "100",
      extralight: "200",
      light: "300",
      normal: "400",
      medium: "500",
      semibold: "600",
      bold: "700",
      extrabold: "800",
      black: "900"
    },
    gap: ({ theme: e }) => e("spacing"),
    gradientColorStops: ({ theme: e }) => e("colors"),
    gradientColorStopPositions: {
      "0%": "0%",
      "5%": "5%",
      "10%": "10%",
      "15%": "15%",
      "20%": "20%",
      "25%": "25%",
      "30%": "30%",
      "35%": "35%",
      "40%": "40%",
      "45%": "45%",
      "50%": "50%",
      "55%": "55%",
      "60%": "60%",
      "65%": "65%",
      "70%": "70%",
      "75%": "75%",
      "80%": "80%",
      "85%": "85%",
      "90%": "90%",
      "95%": "95%",
      "100%": "100%"
    },
    grayscale: {
      0: "0",
      DEFAULT: "100%"
    },
    gridAutoColumns: {
      auto: "auto",
      min: "min-content",
      max: "max-content",
      fr: "minmax(0, 1fr)"
    },
    gridAutoRows: {
      auto: "auto",
      min: "min-content",
      max: "max-content",
      fr: "minmax(0, 1fr)"
    },
    gridColumn: {
      auto: "auto",
      "span-1": "span 1 / span 1",
      "span-2": "span 2 / span 2",
      "span-3": "span 3 / span 3",
      "span-4": "span 4 / span 4",
      "span-5": "span 5 / span 5",
      "span-6": "span 6 / span 6",
      "span-7": "span 7 / span 7",
      "span-8": "span 8 / span 8",
      "span-9": "span 9 / span 9",
      "span-10": "span 10 / span 10",
      "span-11": "span 11 / span 11",
      "span-12": "span 12 / span 12",
      "span-full": "1 / -1"
    },
    gridColumnEnd: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridColumnStart: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12",
      13: "13"
    },
    gridRow: {
      auto: "auto",
      "span-1": "span 1 / span 1",
      "span-2": "span 2 / span 2",
      "span-3": "span 3 / span 3",
      "span-4": "span 4 / span 4",
      "span-5": "span 5 / span 5",
      "span-6": "span 6 / span 6",
      "span-full": "1 / -1"
    },
    gridRowEnd: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7"
    },
    gridRowStart: {
      auto: "auto",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7"
    },
    gridTemplateColumns: {
      none: "none",
      1: "repeat(1, minmax(0, 1fr))",
      2: "repeat(2, minmax(0, 1fr))",
      3: "repeat(3, minmax(0, 1fr))",
      4: "repeat(4, minmax(0, 1fr))",
      5: "repeat(5, minmax(0, 1fr))",
      6: "repeat(6, minmax(0, 1fr))",
      7: "repeat(7, minmax(0, 1fr))",
      8: "repeat(8, minmax(0, 1fr))",
      9: "repeat(9, minmax(0, 1fr))",
      10: "repeat(10, minmax(0, 1fr))",
      11: "repeat(11, minmax(0, 1fr))",
      12: "repeat(12, minmax(0, 1fr))"
    },
    gridTemplateRows: {
      none: "none",
      1: "repeat(1, minmax(0, 1fr))",
      2: "repeat(2, minmax(0, 1fr))",
      3: "repeat(3, minmax(0, 1fr))",
      4: "repeat(4, minmax(0, 1fr))",
      5: "repeat(5, minmax(0, 1fr))",
      6: "repeat(6, minmax(0, 1fr))"
    },
    height: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      full: "100%",
      screen: "100vh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    hueRotate: {
      0: "0deg",
      15: "15deg",
      30: "30deg",
      60: "60deg",
      90: "90deg",
      180: "180deg"
    },
    inset: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      full: "100%"
    }),
    invert: {
      0: "0",
      DEFAULT: "100%"
    },
    keyframes: {
      spin: {
        to: {
          transform: "rotate(360deg)"
        }
      },
      ping: {
        "75%, 100%": {
          transform: "scale(2)",
          opacity: "0"
        }
      },
      pulse: {
        "50%": {
          opacity: ".5"
        }
      },
      bounce: {
        "0%, 100%": {
          transform: "translateY(-25%)",
          animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
        },
        "50%": {
          transform: "none",
          animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
        }
      }
    },
    letterSpacing: {
      tighter: "-0.05em",
      tight: "-0.025em",
      normal: "0em",
      wide: "0.025em",
      wider: "0.05em",
      widest: "0.1em"
    },
    lineHeight: {
      none: "1",
      tight: "1.25",
      snug: "1.375",
      normal: "1.5",
      relaxed: "1.625",
      loose: "2",
      3: ".75rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      9: "2.25rem",
      10: "2.5rem"
    },
    listStyleType: {
      none: "none",
      disc: "disc",
      decimal: "decimal"
    },
    listStyleImage: {
      none: "none"
    },
    margin: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing")
    }),
    lineClamp: {
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6"
    },
    maxHeight: ({ theme: e }) => ({
      ...e("spacing"),
      none: "none",
      full: "100%",
      screen: "100vh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    maxWidth: ({ theme: e, breakpoints: t }) => ({
      none: "none",
      0: "0rem",
      xs: "20rem",
      sm: "24rem",
      md: "28rem",
      lg: "32rem",
      xl: "36rem",
      "2xl": "42rem",
      "3xl": "48rem",
      "4xl": "56rem",
      "5xl": "64rem",
      "6xl": "72rem",
      "7xl": "80rem",
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content",
      prose: "65ch",
      ...t(e("screens"))
    }),
    minHeight: {
      0: "0px",
      full: "100%",
      screen: "100vh",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    },
    minWidth: {
      0: "0px",
      full: "100%",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    },
    objectPosition: {
      bottom: "bottom",
      center: "center",
      left: "left",
      "left-bottom": "left bottom",
      "left-top": "left top",
      right: "right",
      "right-bottom": "right bottom",
      "right-top": "right top",
      top: "top"
    },
    opacity: {
      0: "0",
      5: "0.05",
      10: "0.1",
      20: "0.2",
      25: "0.25",
      30: "0.3",
      40: "0.4",
      50: "0.5",
      60: "0.6",
      70: "0.7",
      75: "0.75",
      80: "0.8",
      90: "0.9",
      95: "0.95",
      100: "1"
    },
    order: {
      first: "-9999",
      last: "9999",
      none: "0",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      6: "6",
      7: "7",
      8: "8",
      9: "9",
      10: "10",
      11: "11",
      12: "12"
    },
    outlineColor: ({ theme: e }) => e("colors"),
    outlineOffset: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    outlineWidth: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    padding: ({ theme: e }) => e("spacing"),
    placeholderColor: ({ theme: e }) => e("colors"),
    placeholderOpacity: ({ theme: e }) => e("opacity"),
    ringColor: ({ theme: e }) => ({
      DEFAULT: e("colors.blue.500", "#3b82f6"),
      ...e("colors")
    }),
    ringOffsetColor: ({ theme: e }) => e("colors"),
    ringOffsetWidth: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    ringOpacity: ({ theme: e }) => ({
      DEFAULT: "0.5",
      ...e("opacity")
    }),
    ringWidth: {
      DEFAULT: "3px",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    rotate: {
      0: "0deg",
      1: "1deg",
      2: "2deg",
      3: "3deg",
      6: "6deg",
      12: "12deg",
      45: "45deg",
      90: "90deg",
      180: "180deg"
    },
    saturate: {
      0: "0",
      50: ".5",
      100: "1",
      150: "1.5",
      200: "2"
    },
    scale: {
      0: "0",
      50: ".5",
      75: ".75",
      90: ".9",
      95: ".95",
      100: "1",
      105: "1.05",
      110: "1.1",
      125: "1.25",
      150: "1.5"
    },
    screens: {
      sm: "640px",
      md: "768px",
      lg: "1024px",
      xl: "1280px",
      "2xl": "1536px"
    },
    scrollMargin: ({ theme: e }) => ({
      ...e("spacing")
    }),
    scrollPadding: ({ theme: e }) => e("spacing"),
    sepia: {
      0: "0",
      DEFAULT: "100%"
    },
    skew: {
      0: "0deg",
      1: "1deg",
      2: "2deg",
      3: "3deg",
      6: "6deg",
      12: "12deg"
    },
    space: ({ theme: e }) => ({
      ...e("spacing")
    }),
    spacing: {
      px: "1px",
      0: "0px",
      0.5: "0.125rem",
      1: "0.25rem",
      1.5: "0.375rem",
      2: "0.5rem",
      2.5: "0.625rem",
      3: "0.75rem",
      3.5: "0.875rem",
      4: "1rem",
      5: "1.25rem",
      6: "1.5rem",
      7: "1.75rem",
      8: "2rem",
      9: "2.25rem",
      10: "2.5rem",
      11: "2.75rem",
      12: "3rem",
      14: "3.5rem",
      16: "4rem",
      20: "5rem",
      24: "6rem",
      28: "7rem",
      32: "8rem",
      36: "9rem",
      40: "10rem",
      44: "11rem",
      48: "12rem",
      52: "13rem",
      56: "14rem",
      60: "15rem",
      64: "16rem",
      72: "18rem",
      80: "20rem",
      96: "24rem"
    },
    stroke: ({ theme: e }) => ({
      none: "none",
      ...e("colors")
    }),
    strokeWidth: {
      0: "0",
      1: "1",
      2: "2"
    },
    supports: {},
    data: {},
    textColor: ({ theme: e }) => e("colors"),
    textDecorationColor: ({ theme: e }) => e("colors"),
    textDecorationThickness: {
      auto: "auto",
      "from-font": "from-font",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    textIndent: ({ theme: e }) => ({
      ...e("spacing")
    }),
    textOpacity: ({ theme: e }) => e("opacity"),
    textUnderlineOffset: {
      auto: "auto",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      8: "8px"
    },
    transformOrigin: {
      center: "center",
      top: "top",
      "top-right": "top right",
      right: "right",
      "bottom-right": "bottom right",
      bottom: "bottom",
      "bottom-left": "bottom left",
      left: "left",
      "top-left": "top left"
    },
    transitionDelay: {
      0: "0s",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      300: "300ms",
      500: "500ms",
      700: "700ms",
      1e3: "1000ms"
    },
    transitionDuration: {
      DEFAULT: "150ms",
      0: "0s",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      300: "300ms",
      500: "500ms",
      700: "700ms",
      1e3: "1000ms"
    },
    transitionProperty: {
      none: "none",
      all: "all",
      DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
      colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
      opacity: "opacity",
      shadow: "box-shadow",
      transform: "transform"
    },
    transitionTimingFunction: {
      DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
      linear: "linear",
      in: "cubic-bezier(0.4, 0, 1, 1)",
      out: "cubic-bezier(0, 0, 0.2, 1)",
      "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
    },
    translate: ({ theme: e }) => ({
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      full: "100%"
    }),
    width: ({ theme: e }) => ({
      auto: "auto",
      ...e("spacing"),
      "1/2": "50%",
      "1/3": "33.333333%",
      "2/3": "66.666667%",
      "1/4": "25%",
      "2/4": "50%",
      "3/4": "75%",
      "1/5": "20%",
      "2/5": "40%",
      "3/5": "60%",
      "4/5": "80%",
      "1/6": "16.666667%",
      "2/6": "33.333333%",
      "3/6": "50%",
      "4/6": "66.666667%",
      "5/6": "83.333333%",
      "1/12": "8.333333%",
      "2/12": "16.666667%",
      "3/12": "25%",
      "4/12": "33.333333%",
      "5/12": "41.666667%",
      "6/12": "50%",
      "7/12": "58.333333%",
      "8/12": "66.666667%",
      "9/12": "75%",
      "10/12": "83.333333%",
      "11/12": "91.666667%",
      full: "100%",
      screen: "100vw",
      min: "min-content",
      max: "max-content",
      fit: "fit-content"
    }),
    willChange: {
      auto: "auto",
      scroll: "scroll-position",
      contents: "contents",
      transform: "transform"
    },
    zIndex: {
      auto: "auto",
      0: "0",
      10: "10",
      20: "20",
      30: "30",
      40: "40",
      50: "50"
    }
  },
  plugins: []
};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return o;
    }
  });
  const t = /* @__PURE__ */ a(Nl), n = Dt;
  function a(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  function o(r) {
    var i;
    const u = ((i = r == null ? void 0 : r.presets) !== null && i !== void 0 ? i : [
      t.default
    ]).slice().reverse().flatMap((d) => o(d instanceof Function ? d() : d)), l = {
      // Add experimental configs here...
      respectDefaultRingColorOpacity: {
        theme: {
          ringColor: ({ theme: d }) => ({
            DEFAULT: "#3b82f67f",
            ...d("colors")
          })
        }
      },
      disableColorOpacityUtilitiesByDefault: {
        corePlugins: {
          backgroundOpacity: !1,
          borderOpacity: !1,
          divideOpacity: !1,
          placeholderOpacity: !1,
          ringOpacity: !1,
          textOpacity: !1
        }
      }
    }, c = Object.keys(l).filter((d) => (0, n.flagEnabled)(r, d)).map((d) => l[d]);
    return [
      r,
      ...c,
      ...u
    ];
  }
})(na);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return o;
    }
  });
  const t = /* @__PURE__ */ a(xr), n = /* @__PURE__ */ a(na);
  function a(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  function o(...r) {
    let [, ...i] = (0, n.default)(r[0]);
    return (0, t.default)([
      ...r,
      ...i
    ]);
  }
})(Dr);
let Ut = Dr;
var Tl = (Ut.__esModule ? Ut : { default: Ut }).default;
const Ll = /* @__PURE__ */ Xi(Tl);
function Fl(e) {
  var a;
  if (!e)
    throw Error("No tailwind config passed as argument to useTailwindBreakpoints function");
  const n = (a = Ll(e).theme) == null ? void 0 : a.screens;
  return Ai(n);
}
function Jn(e) {
  const t = e.value;
  if (!t)
    return "";
  const n = t.textContent;
  return n ? n.trim() : "";
}
function Ul(e) {
  const t = Z("");
  return Di(e, (n) => {
    n[0] && (t.value = Jn(e));
  }, {
    childList: !0,
    characterData: !0,
    attributes: !0,
    subtree: !0
  }), bt(() => {
    t.value = Jn(e);
  }), {
    content: t
  };
}
export {
  zi as CluberBreakpoints,
  _a as Key,
  ar as mount,
  Vi as timeFormatDayFull,
  Wi as timeFormatDayFullShort,
  $i as timeFormatDayName,
  Gi as timeFormatDayNumeric,
  Hi as timeFormatDayShort,
  Ri as timeFormatFull,
  Mi as timeFormatFullNumeric,
  Xn as timeFormatHour,
  ji as timeFormatMonthFullShort,
  Fi as timeFormatMonthName,
  Ui as timeFormatMonthNumber,
  ga as useBrowserFingerprint,
  kl as useBrowserTabTitle,
  Pl as useCluberLocalStorage,
  Dl as useDateLocale,
  xl as useEncryption,
  Rl as useFileDialog,
  Ml as useGeolocation,
  wl as useInjectedSetup,
  Cl as useSetup,
  Fl as useTailwindBreakpoints,
  Ul as useTextContent
};
//# sourceMappingURL=composables.es.js.map
